<mat-card
  style="background-color: #003057; border: none"
  class="mat-elevation-z10"
>
  <mat-card-content>
    <div class="form-bg" *ngIf="!preference">
      <div
        *ngIf="errorMessageIntialData == ''"
        class="d-flex justify-content-center alert alert-warning alert-dismissible fade show"
        role="alert"
      >
        <div *ngIf="errorMessageIntialData == ''">
          Loading...
          <div class="spinner-border text-primary" role="status"></div>
        </div>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="alert"
          aria-label="Close"
        ></button>
      </div>
    </div>
    <div
      *ngIf="errorMessage != ''"
      class="d-flex justify-content-center alert alert-danger alert-dismissible fade show fs-3"
      role="alert"
      (closed)="errorMessage = ''"
    >
      <i class="bi bi-exclamation-triangle-fill px-2"></i>

      <div [innerHTML]="errorMessage"></div>
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="alert"
        aria-label="Close"
      ></button>
    </div>
    <div
      *ngIf="successMessage != ''"
      class="d-flex justify-content-center alert alert-success alert-dismissible fade show fs-3"
      role="alert"
      (closed)="successMessage = ''"
    >
      <i class="bi bi-check-circle-fill px-2"></i>

      <div [innerHTML]="successMessage"></div>
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="alert"
        aria-label="Close"
      ></button>
    </div>
    <div
      *ngIf="warningMessage != ''"
      class="d-flex justify-content-center alert alert-warning alert-dismissible fade show fs-3"
      role="alert"
      (closed)="warningMessage = ''"
    >
      <i class="bi bi-exclamation-triangle-fill px-2"></i>

      <div [innerHTML]="warningMessage"></div>
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="alert"
        aria-label="Close"
      ></button>
    </div>
    <div *ngIf="!isValidFormSubmitted">
      <div class="form-bg" *ngIf="preference">
        <form
          focusFirstInvalidField
          #customerForm="ngForm"
          name="customerForm"
          class="customer-form"
          novalidate
        >
          <div class="container-fluid">
            <div class="row">
              <app-timer-ga [resetTime]="timerReset"
                [isValidFormSubmitted]="isValidFormSubmitted"
                (changeResetMessageCalled)="changeResetMessage()"
              ></app-timer-ga>
            </div>
            <div class="row">
              <div class="col fw-bold" style="color: yellow">
                * These are required fields. Make sure you fill in these boxes.
              </div>
            </div>
            <mat-horizontal-stepper  labelPosition="bottom"
              linear
              #stepper
              class="rounded"
              style="border: 2px solid #63b1bc"
              aria-busy="true"
            >
              <mat-step
                label="Policyholder Info"  aria-label="Create Policyholder Info"
                [completed]="policyHolderCheck()"
              >
                <fieldset
                  class="shadow p-5 mb-1 rounded-5"
                  style="border: 2px solid #63b1bc"
                >
                  <legend
                    class="float-none w-auto p-1 mx-5 fw-bold fs-1"
                    style="color: #0f6db7"
                  > <ng-container *ngIf="existingMember == 'Yes'">Update Now</ng-container>
                  <ng-container *ngIf="existingMember != 'Yes'">Apply Now</ng-container>
                    
                  </legend>
                  <input
                    type="hidden"
                    name="existingMember"
                    [(ngModel)]="existingMember"
                    #existingMembers="ngModel"
                    style="display: none"
                  />
                  <mat-card
                    *ngIf="existingMember == null"
                    class="mat-elevation-z8"
                  >
                    <mat-card-header>
                      <mat-card-subtitle
                        ><strong
                          >Complete the following information for the health
                          insurance policy holder</strong
                        ></mat-card-subtitle
                      >
                    </mat-card-header>
                    <mat-card-content>
                      <br />
                      <div class="row">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >First Name<ng-container
                                *ngIf="!firstNameRequired"
                                >*</ng-container
                              ></mat-label
                            >

                            <input
                              matInput
                              type="text"
                              name="memberVO.firstNm"
                              [(ngModel)]="memberObj1.firstNm"
                              uppercase
                              #memberVOfirstNm="ngModel"
                              pattern="^[a-zA-Z](?!.*--)(?!.*-')(?!.* ')(?!.*'-)(?!.*' )(?!.* -)(?!.*- )(?!.*  )(?!.*'')[a-zA-Z \-']+$"
                              maxlength="20"
                              (keypress)="
                                allowAlphabets2($event, memberVOfirstNm)
                              "
                              (blur)="nomatchCheck($event, memberVOfirstNm)"
                              [required]="firstNameRequired"
                              #memberVO.firstNm="ngModel"
                            />
                            <mat-error
                              *ngIf="memberVOfirstNm.errors?.['required'] && !memberVOfirstNm.errors?.['nomatch']"
                              >First Name is required</mat-error
                            >
                            <mat-error
                              *ngIf="memberVOfirstNm.errors?.['invalid']"
                              >First Name is invalid</mat-error
                            >
                            <mat-error
                              *ngIf="memberVOfirstNm.errors?.['pattern']"
                              >First Name is invalid</mat-error
                            >
                            <mat-error
                              *ngIf="memberVOfirstNm.errors?.['nomatch']"
                              >Only Alphabetical, Space, Hyphen and ' are allowed</mat-error
                            >
                          </mat-form-field>
                        </div>

                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >Last Name<ng-container *ngIf="!lastNameRequired"
                                >*</ng-container
                              ></mat-label
                            >
                            <input
                              matInput
                              type="text"
                              name="memberVO.lastNm"
                              [(ngModel)]="memberObj1.lastNm"
                              uppercase
                              maxlength="25"
                              pattern="^[a-zA-Z](?!.*--)(?!.*-')(?!.* ')(?!.*'-)(?!.*' )(?!.* -)(?!.*- )(?!.*  )(?!.*'')[a-zA-Z \-']+$"
                              #memberVOLastNm="ngModel"
                              (keypress)="
                                allowAlphabets2($event, memberVOLastNm)
                              "
                              (blur)="nomatchCheck($event, memberVOLastNm)"
                              [required]="lastNameRequired"
                            />
                            <mat-error
                              *ngIf="memberVOLastNm.errors?.['required'] && !memberVOLastNm.errors?.['nomatch']"
                              >Last Name is required</mat-error
                            >
                            <mat-error
                              *ngIf="memberVOLastNm.errors?.['invalid']"
                              >Last Name is invalid</mat-error
                            >
                            <mat-error
                              *ngIf="memberVOLastNm.errors?.['pattern']"
                              >Last Name is invalid</mat-error
                            >
                            <mat-error
                              *ngIf="memberVOLastNm.errors?.['nomatch']"
                              >Only Alphabetical, Space, Hyphen and ' are allowed</mat-error
                            >
                          </mat-form-field>
                        </div>

                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >Social Security Number<ng-container
                                *ngIf="!ssnMemberRequired"
                                >*</ng-container
                              ></mat-label
                            >
                            <input
                              matInput
                              type="text"
                              name="memberObj.ssnNum"
                              [(ngModel)]="memberObj1.ssnNum"
                              (input)="
                                memberObj1.ssnNum = ssnmask($event, MemberSsn)
                              "
                              maxlength="11"
                              #MemberSsn="ngModel"
                              (blur)="verifySSN($event, false, MemberSsn)"
                              [required]="ssnMemberRequired"
                              pattern="^\d{3}-\d{2}-\d{4}$"
                              (keypress)="isNumeric($event, MemberSsn)"
                            />
                            <mat-error *ngIf="MemberSsn.errors?.['required'] && !MemberSsn.errors?.['nomatch']"
                              >Social Security Number is required</mat-error
                            >
                            <mat-error *ngIf="MemberSsn.errors?.['invalidSsn']"
                              >Social Security Number is invalid</mat-error
                            >
                            <mat-error *ngIf="MemberSsn.errors?.['pattern']">
                              <ng-container
                                *ngIf="memberObj1.ssnNum.length < 11"
                                >Social Security Number length is
                                short</ng-container
                              >
                              <ng-container
                                *ngIf="memberObj1.ssnNum.length > 10"
                                >Social Security Number is invalid</ng-container
                              >
                            </mat-error>
                            <mat-error
                              *ngIf="MemberSsn.errors?.['recordPresent']"
                              >{{ getSSNUsedMessage() }}</mat-error
                            >
                            <mat-error *ngIf="MemberSsn.errors?.['nomatch']"
                              >Only numerical values are allowed</mat-error
                            >
                          </mat-form-field>
                        </div>

                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >Date of Birth<ng-container
                                *ngIf="!memberDobRequired"
                                >*</ng-container
                              ></mat-label
                            >
                            <input
                              matInput
                              [min]="prev100year"
                              [max]="minAge18"
                              [matDatepicker]="picker"
                              name="d1"
                              #c1="ngModel"
                              [(ngModel)]="memberVOdobDt"
                              [required]="memberDobRequired"
                              minlength="8"
                              maxlength="10"
                              placeholder="MMDDYYYY"
                              (input)="datemask2($event, c1)"
                              (blur)="parseDate($event, c1)"
                              (keypress)="onlyNumeric($event, c1)"
                            />

                            <mat-datepicker-toggle
                              matIconSuffix
                              [for]="picker"
                            ></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                            <mat-error *ngIf="c1.errors?.['required'] && !c1.errors?.['nomatch']"
                              >Date of Birth is required</mat-error
                            >
                            <mat-error *ngIf="c1.errors?.['invalid']"
                              >Date of Birth is invalid</mat-error
                            >
                            <mat-error *ngIf="c1.errors?.['matDatepickerMin']"
                              >Date of Birth is out of range</mat-error
                            >
                            <mat-error *ngIf="c1.errors?.['matDatepickerMax']"
                              >Must be at least 18 years old</mat-error
                            >
                            <mat-error *ngIf="c1.errors?.['nomatch']"
                              >Only numerical values are allowed</mat-error
                            >
                            <mat-error *ngIf="c1.errors?.['invalidDate']"
                              >Date of Birth is invalid</mat-error
                            >
                          </mat-form-field>
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col text-center">
                          <button
                            id="verifyMemberId"
                            mat-raised-button
                            color="primary"
                            matStepperNext
                            type="button"
                            class="m-1"
                            (click)="verifyMemberFn(c1)"
                          >
                            Verify Member
                          </button>
                        </div>
                      </div>
                    </mat-card-content>
                  </mat-card>
                  <br *ngIf="existingMember == null" />
                  <mat-card
                    *ngIf="existingMember == 'Yes'"
                    class="mat-elevation-z4"
                  >
                    <br />
                    <mat-card-header>
                      <mat-card-subtitle
                        ><mat-label
                          ><strong
                            >Select one:
                            <span class="text-danger">*</span></strong
                          ></mat-label
                        ></mat-card-subtitle
                      >
                    </mat-card-header>
                    <mat-card-content>
                      <mat-radio-group
                        #group
                        color="primary"
                        aria-label="Select an option"
                        [(ngModel)]="updateReason"
                        [required]="updateReasonRequired"
                        name="updateReason"
                        #updateReasons="ngModel"
                        class="example-radio-group"
                      >
                        <mat-radio-button
                          value="CHANGE"
                          [required]="updateReasonRequired"
                          class="example-radio-button"
                        >
                          I am reporting a change in my GAHIPP case
                        </mat-radio-button>
                        <mat-radio-button
                          value="RECERT"
                          [required]="updateReasonRequired"
                          class="example-radio-button"
                        >
                          I am completing my renewal
                        </mat-radio-button>
                      </mat-radio-group>
                      <mat-error
                        *ngIf="updateReasons.errors?.['required'] && customerForm.submitted"
                        >Your response is required</mat-error
                      >
                    </mat-card-content>
                  </mat-card>

                  <div *ngIf="existingMember != null">
                    <!--|| updateReason !=''-->

                    <div *ngIf="existingMember == 'No'" class="row">
                      <div class="col">
                        <mat-form-field appearance="outline">
                          <mat-label class="fw-bold"
                            >How did you hear about GAHIPP?<ng-container
                              *ngIf="!refferalSourceRequired"
                              >*</ng-container
                            ></mat-label
                          >
                          <select
                            matNativeControl
                            required
                            name="caseVO.referralSource"
                            [required]="refferalSourceRequired"
                            [(ngModel)]="formGa.referralCase.referralSource"
                            #RefferralSource="ngModel"
                          >
                            <ng-container
                              *ngIf="preference.dropDownValues != null"
                            >
                              <option
                                *ngFor="
                                  let info of preference.dropDownValues[
                                    'OSRCCD'
                                  ] | keyvalue : originalOrder
                                "
                                [value]="info.key"
                              >
                                {{ info.value }}
                              </option>
                            </ng-container>
                          </select>
                          <mat-error
                            *ngIf="RefferralSource.errors?.['required']"
                            >Source is required</mat-error
                          >
                        </mat-form-field>
                      </div>
                      <div class="col"></div>
                    </div>
                    <br *ngIf="existingMember == 'Yes'" />
                    <mat-card class="mat-elevation-z4">
                      <mat-card-header>
                        <mat-card-subtitle
                          ><strong
                            >Complete the following information for the health 
                            insurance policy holder</strong
                          ></mat-card-subtitle
                        >
                      </mat-card-header>
                      <mat-card-content>
                        <br />
                        <div class="row">
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >First Name<ng-container
                                  *ngIf="!firstNameRequired"
                                  >*</ng-container
                                ></mat-label
                              >

                              <input
                                matInput
                                type="text"
                                name="memberVO.firstNm"
                                [(ngModel)]="memberObj1.firstNm"
                                uppercase
                                #memberVOfirstNm="ngModel"
                                pattern="^[a-zA-Z](?!.*--)(?!.*-')(?!.* ')(?!.*'-)(?!.*' )(?!.* -)(?!.*- )(?!.*  )(?!.*'')[a-zA-Z \-']+$"
                                maxlength="20"
                                (keypress)="
                                  allowAlphabets2($event, memberVOfirstNm)
                                "
                                (blur)="nomatchCheck($event, memberVOfirstNm)"
                                [required]="firstNameRequired"
                                #memberVO.firstNm="ngModel"
                                id="memberFirstName"
                              />
                              <mat-error
                                *ngIf="memberVOfirstNm.errors?.['required'] && !memberVOfirstNm.errors?.['nomatch']"
                                >First Name is required</mat-error
                              >
                              <mat-error
                                *ngIf="memberVOfirstNm.errors?.['invalid']"
                                >First Name is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="memberVOfirstNm.errors?.['pattern']"
                                >First Name is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="memberVOfirstNm.errors?.['nomatch']"
                                >Only Alphabetical, Space, Hyphen and ' are allowed</mat-error
                              >
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>MI</mat-label>
                              <input
                                matInput
                                type="text"
                                name="memberVO.miNm"
                                [(ngModel)]="memberObj1.miNm"
                                uppercase
                                maxlength="1"
                                #memberVOMi="ngModel"
                                (keypress)="
                                  allowOnlyOneAlphabet($event, memberVOMi)
                                "
                              />
                              <mat-error *ngIf="memberVOMi.errors?.['invalid']"
                                >Middle Name is invalid</mat-error
                              >
                              <mat-error *ngIf="memberVOMi.errors?.['nomatch']"
                                >Only Alphabet is allowed</mat-error
                              >
                            </mat-form-field>
                          </div>

                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >Last Name<ng-container
                                  *ngIf="!lastNameRequired"
                                  >*</ng-container
                                ></mat-label
                              >
                              <input
                                matInput
                                type="text"
                                name="memberVO.lastNm"
                                [(ngModel)]="memberObj1.lastNm"
                                uppercase
                                maxlength="25"
                                pattern="^[a-zA-Z](?!.*--)(?!.*-')(?!.* ')(?!.*'-)(?!.*' )(?!.* -)(?!.*- )(?!.*  )(?!.*'')[a-zA-Z \-']+$"
                                #memberVOLastNm="ngModel"
                                (keypress)="
                                  allowAlphabets2($event, memberVOLastNm)
                                "
                                (blur)="nomatchCheck($event, memberVOLastNm)"
                                [required]="lastNameRequired"
                              />
                              <mat-error
                                *ngIf="memberVOLastNm.errors?.['required'] && !memberVOLastNm.errors?.['nomatch']"
                                >Last Name is required</mat-error
                              >
                              <mat-error
                                *ngIf="memberVOLastNm.errors?.['invalid']"
                                >Last Name is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="memberVOLastNm.errors?.['pattern']"
                                >Last Name is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="memberVOLastNm.errors?.['nomatch']"
                                >Only Alphabetical, Space, Hyphen and ' are allowed</mat-error
                              >
                            </mat-form-field>
                          </div>
                        </div>
                        <br />
                        <div class="row">
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >Social Security Number<ng-container
                                  *ngIf="!ssnMemberRequired"
                                  >*</ng-container
                                ></mat-label
                              >
                              <input
                                matInput
                                type="text"
                                name="memberObj.ssnNum"
                                [(ngModel)]="memberObj1.ssnNum"
                                (input)="
                                  memberObj1.ssnNum = ssnmask($event, MemberSsn)
                                "
                                maxlength="11"
                                #MemberSsn="ngModel"
                                (blur)="verifySSN($event, false, MemberSsn)"
                                [required]="ssnMemberRequired"
                                pattern="^\d{3}-\d{2}-\d{4}$"
                                (keypress)="isNumeric($event, MemberSsn)"
                                readonly
                              />
                              <mat-error *ngIf="MemberSsn.errors?.['required'] && !MemberSsn.errors?.['nomatch']"
                                >Social Security Number is required</mat-error
                              >
                              <mat-error
                                *ngIf="MemberSsn.errors?.['invalidSsn']"
                                >Social Security Number is invalid</mat-error
                              >
                              <mat-error *ngIf="MemberSsn.errors?.['pattern']">
                                <ng-container
                                  *ngIf="memberObj1.ssnNum.length < 11"
                                  >Social Security Number length is
                                  short</ng-container
                                >
                                <ng-container
                                  *ngIf="memberObj1.ssnNum.length > 10"
                                  >Social Security Number is
                                  invalid</ng-container
                                >
                              </mat-error>
                              <mat-error
                                *ngIf="MemberSsn.errors?.['recordPresent']"
                                >{{ getSSNUsedMessage() }}</mat-error
                              >
                              <mat-error *ngIf="MemberSsn.errors?.['nomatch']"
                                >Only numerical values are allowed</mat-error
                              >
                            </mat-form-field>
                          </div>

                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >Date of Birth<ng-container
                                  *ngIf="!memberDobRequired"
                                  >*</ng-container
                                ></mat-label
                              >
                              <input
                                matInput
                                [min]="prev100year"
                                [max]="minAge18"
                                [matDatepicker]="picker"
                                name="d1"
                                #c1="ngModel"
                                [(ngModel)]="memberVOdobDt"
                                [required]="memberDobRequired"
                                minlength="8"
                                maxlength="10"
                                placeholder="MMDDYYYY"
                                (input)="datemask2($event, c1)"
                                (blur)="parseDate($event, c1)"
                                (keypress)="onlyNumeric($event, c1)"
                                readonly
                              />

                              <mat-datepicker-toggle
                                matIconSuffix
                                [for]="picker"
                                disabled
                              ></mat-datepicker-toggle>
                              <mat-datepicker #picker></mat-datepicker>
                              <mat-error *ngIf="c1.errors?.['required'] && !c1.errors?.['nomatch']"
                                >Date of Birth is required</mat-error
                              >
                              <mat-error *ngIf="c1.errors?.['invalid']"
                                >Date of Birth is invalid</mat-error
                              >
                              <mat-error *ngIf="c1.errors?.['matDatepickerMin']"
                                >Date of Birth is out of range</mat-error
                              >
                              <mat-error *ngIf="c1.errors?.['matDatepickerMax']"
                                >Must be at least 18 years old</mat-error
                              >
                              <mat-error *ngIf="c1.errors?.['nomatch']"
                                >Only numerical values are allowed</mat-error
                              >
                              <mat-error *ngIf="c1.errors?.['invalidDate']"
                                >Date of Birth is invalid</mat-error
                              >
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >Gender<ng-container *ngIf="!memberGenderRequired"
                                  >*</ng-container
                                ></mat-label
                              >
                              <select
                                matNativeControl
                                name="memberVO.gencdRf"
                                [(ngModel)]="memberObj1.genderCd"
                                #memberObjGencdRf="ngModel"
                                (change)="isGenderFn()"
                                [required]="memberGenderRequired"
                              >
                                <ng-container
                                  *ngIf="preference.dropDownValues != null"
                                >
                                  <option
                                    *ngFor="
                                      let g of preference.dropDownValues[
                                        'GENCD'
                                      ] | keyvalue : originalOrder
                                    "
                                    [value]="g.key"
                                  >
                                    {{ g.value }}
                                  </option>
                                </ng-container>
                              </select>
                              <mat-error
                                *ngIf="memberObjGencdRf.errors?.['required']"
                                >Gender is required</mat-error
                              >
                            </mat-form-field>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col">
                            <mat-label
                              >Is this person a Medicaid recipient?
                              <span class="text-danger">*</span></mat-label
                            >

                            <mat-radio-group
                              #group
                              color="primary"
                              aria-label="Select an option"
                              [(ngModel)]="isMemberMedicaid"
                              [required]="memberMedicateRequired"
                              name="isMemberMedicaid"
                              #isMedicated="ngModel"
                              (change)="isMemberMedicaidClick()"
                            >
                              <mat-radio-button
                                value="Yes"
                                [required]="memberMedicateRequired"
                              >
                                Yes
                              </mat-radio-button>
                              <mat-radio-button
                                value="No"
                                [required]="memberMedicateRequired"
                              >
                                No
                              </mat-radio-button>
                            </mat-radio-group>
                            <mat-error
                              *ngIf="isMedicated.errors?.['required'] && customerForm.submitted"
                              >Your response is required</mat-error
                            >
                          </div>
                          <div class="col" *ngIf="isMemberMedicaid == 'Yes'">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >Medicaid ID Number<ng-container
                                  *ngIf="!memberVOmaNumRequired"
                                  >*</ng-container
                                ></mat-label
                              >
                              <input
                                matInput
                                type="text"
                                name="memberVO.maNum"
                                [(ngModel)]="memberObj1.maNum"
                                uppercase
                                maxlength="12"
                                pattern="^\d{12}$"
                                #memberVOmaNum="ngModel"
                                (keypress)="isNumeric($event, memberVOmaNum)"
                                (blur)="isMedicaidValid($event, memberVOmaNum)"
                                [required]="memberVOmaNumRequired"
                              />
                              <mat-error
                                *ngIf="memberVOmaNum.errors?.['required'] && !memberVOmaNum.errors?.['nomatch']"
                                >Medicaid ID is required</mat-error
                              >
                              <mat-error
                                *ngIf="memberVOmaNum.errors?.['pattern']"
                                >Medicaid ID is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="memberVOmaNum.errors?.['invalid']"
                                >Medicaid ID is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="memberVOmaNum.errors?.['invalid2']"
                                >Medicaid ID number should start with 111 or 222.</mat-error
                              >   
                              <mat-error
                                *ngIf="memberVOmaNum.errors?.['nomatch']"
                                >Only numerical values are allowed</mat-error
                              >
                            </mat-form-field>
                          </div>
                        </div>
                        <br
                          *ngIf="
                            isMemberMedicaid == 'Yes' && memberObj1.genderCd == 'F'
                          "
                        />
                        <div
                          *ngIf="
                            isMemberMedicaid == 'Yes' && memberObj1.genderCd == 'F'
                          "
                          class="row"
                        >
                          <div class="col">
                            <mat-label
                              >Is this person pregnant?
                              <span class="text-danger">*</span></mat-label
                            >

                            <mat-radio-group
                              #group
                              color="primary"
                              aria-label="Select an option"
                              [(ngModel)]="pregnantMember"
                              name="pregnantMember"
                              #pregnantMem="ngModel"
                              (change)="isPregnantMember()"
                              [required]="pregnantMemberRequired"
                            >
                              <mat-radio-button
                                value="Yes"
                                [required]="pregnantMemberRequired"
                              >
                                Yes
                              </mat-radio-button>
                              <mat-radio-button
                                value="No"
                                [required]="pregnantMemberRequired"
                              >
                                No
                              </mat-radio-button>
                            </mat-radio-group>
                          </div>
                          <mat-error
                            *ngIf="pregnantMem.errors?.['required'] && customerForm.submitted"
                            >Your response is required</mat-error
                          >

                          <div class="col">
                            <div *ngIf="pregnantMember == 'Yes'">
                              <mat-form-field appearance="outline">
                                <mat-label
                                  >Due Date<ng-container
                                    *ngIf="!dueDateRequired"
                                    >*</ng-container
                                  ></mat-label
                                >
                                <input
                                  matInput
                                  [min]="today"
                                  [max]="plus1year"
                                  [matDatepicker]="picker2"
                                  name="d2"
                                  #c2="ngModel"
                                  [(ngModel)]="memberVODuedate"
                                  [required]="dueDateRequired"
                                  minlength="8"
                                  maxlength="10"
                                  (input)="datemask2($event, c2)"
                                  (blur)="parseDate($event, c2)"
                                  placeholder="MMDDYYYY"
                                  (keypress)="onlyNumeric($event, c2)"
                                />

                                <mat-datepicker-toggle
                                  matIconSuffix
                                  [for]="picker2"
                                ></mat-datepicker-toggle>
                                <mat-datepicker #picker2></mat-datepicker>
                                <mat-error *ngIf="c2.errors?.['required'] && !c2.errors?.['nomatch']"
                                  >Due Date is required</mat-error
                                >
                                <mat-error *ngIf="c2.errors?.['invalid']"
                                  >Due Date is invalid</mat-error
                                >
                                <mat-error
                                  *ngIf="c2.errors?.['matDatepickerMin']"
                                  >Due Date out of range</mat-error
                                >
                                <mat-error
                                  *ngIf="c2.errors?.['matDatepickerMax']"
                                  >Due Date out of range</mat-error
                                >
                                <mat-error *ngIf="c2.errors?.['nomatch']"
                                  >Only numerical values are allowed</mat-error
                                >
                                <mat-error *ngIf="c2.errors?.['invalidDate']"
                                  >Due Date is invalid</mat-error
                                >
                              </mat-form-field>
                            </div>
                          </div>
                        </div>

                        <br *ngIf="isMemberMedicaid == 'Yes'" />
                        <div *ngIf="isMemberMedicaid == 'Yes'" class="row">
                          <div class="col">
                            <mat-label
                              >Is this family member enrolled in one of the following Care Management Organization (CMO): Caresource, Amerigroup or Peachstate Health Plan?
                              <span class="text-danger">*</span>
                            </mat-label>
                            <br />
                            <mat-radio-group
                              color="primary"
                              aria-label="CMO enrollment"
                              [(ngModel)]="isMemberCmoEnrolled"
                              name="isMemberCmoEnrolled"
                              #isMemberCmoEnrolledResp="ngModel"
                              [required]="isMemberCmoEnrolledRequired"
                              (change)="memberCmoProceed = ''; memberCmoProceedRequired = false"
                            >
                              <mat-radio-button value="Yes">Yes</mat-radio-button>
                              <mat-radio-button value="No">No</mat-radio-button>
                            </mat-radio-group>
                            <mat-error *ngIf="isMemberCmoEnrolledResp.errors?.['required'] && customerForm.submitted">Your response is required</mat-error>
                          </div>
                        </div>

                        <div *ngIf="isMemberCmoEnrolled == 'Yes'" class="row mt-3">
                          <div class="col">
                            <mat-label>
                              If you are eligible and approved for HIPP while enrolled in a CMO, you will be disenrolled from the CMO and enrolled in the Fee-For-Service (FFS) traditional Medicaid program. Under FFS Medicaid, the State of Georgia pays providers directly on a per-service basis. We encourage you to compare the benefits and services offered to determine what best suits your family's needs.
                              <a style="color: #064EBA; cursor: pointer;" aria-label="Download CMO FAQ" (click)="openCMOFAQ()">CMO FAQ</a> Would you like to proceed with your application?
                              <span class="text-danger">*</span>
                            </mat-label>
                            <br />
                            <mat-radio-group
                              color="primary"
                              aria-label="CMO proceed"
                              [(ngModel)]="memberCmoProceed"
                              name="memberCmoProceed"
                              #memberCmoProceedResp="ngModel"
                              (change)="memberCmoBlock = false"
                              [required]="memberCmoProceedRequired"
                            >
                              <mat-radio-button value="Yes">Yes</mat-radio-button>
                              <mat-radio-button value="No">No</mat-radio-button>
                            </mat-radio-group>
                            <mat-error *ngIf="memberCmoProceedResp.errors?.['required'] && customerForm.submitted">Your response is required</mat-error>
                            <br />
                            <mat-error *ngIf="memberCmoBlock">
                              You must select "Yes" to proceed with your application.
                            </mat-error>
                          </div>
                        </div>
                      </mat-card-content>
                    </mat-card>

                    <br />
                    <mat-card class="mat-elevation-z4">
                      <mat-card-header>
                        <mat-card-subtitle
                          ><label
                            ><strong> Contact Information </strong>
                          </label></mat-card-subtitle
                        >
                      </mat-card-header>
                      <br />
                      <mat-card-content>
                        <div class="row">
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>Primary Phone<ng-container *ngIf="!phone1Required">*</ng-container></mat-label>
                              <input
                                matInput
                                type="text"
                                name="caseVO.phone1Num"
                                [(ngModel)]="formGa.referralCase.phone1Num"
                                (input)="
                                  formGa.referralCase.phone1Num = phonemask2(
                                    $event,
                                    caseVOphone1Num
                                  )
                                "
                                (blur)="phoneCheck($event, caseVOphone1Num)"
                                maxlength="12"
                                pattern="^\d{3}-\d{3}-\d{4}$"
                                (keypress)="isNumeric($event, caseVOphone1Num)"
                                #caseVOphone1Num="ngModel"
                                [required]="phone1Required"
                              />
                              <mat-error
                                *ngIf="caseVOphone1Num.errors?.['required'] && !caseVOphone1Num.errors?.['nomatch']"
                                >Phone Number is required</mat-error
                              >
                              <mat-error
                                *ngIf="caseVOphone1Num.errors?.['invalid']"
                                >Phone Number is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="caseVOphone1Num.errors?.['pattern']"
                                >Phone Number is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="caseVOphone1Num.errors?.['minlength']"
                                >Phone Number is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="caseVOphone1Num.errors?.['nomatch']"
                                >Only numerical values are allowed</mat-error
                              >
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>Secondary Phone</mat-label>
                              <input
                                matInput
                                type="text"
                                name="caseVO.phone2Num"
                                [(ngModel)]="formGa.referralCase.phone2Num"
                                (input)="
                                  formGa.referralCase.phone2Num = phonemask2(
                                    $event,
                                    caseVOphone2Num
                                  )
                                "
                                (blur)="phoneCheck($event, caseVOphone2Num)"
                                maxlength="12"
                                pattern="^\d{3}-\d{3}-\d{4}$"
                                (keypress)="isNumeric($event, caseVOphone2Num)"
                                #caseVOphone2Num="ngModel"
                              />
                              <mat-error
                                *ngIf="caseVOphone2Num.errors?.['required'] && !caseVOphone2Num.errors?.['nomatch']"
                                >Phone Number is required</mat-error
                              >
                              <mat-error
                                *ngIf="caseVOphone2Num.errors?.['invalid']"
                                >Phone Number is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="caseVOphone2Num.errors?.['pattern']"
                                >Phone Number is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="caseVOphone2Num.errors?.['minlength']"
                                >Phone Number is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="caseVOphone2Num.errors?.['nomatch']"
                                >Only numerical values are allowed</mat-error
                              >
                            </mat-form-field>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >Email Address<ng-container *ngIf="!emailTxtRequired">*</ng-container></mat-label
                              >
                              <input
                                matInput
                                type="text"
                                name="caseVO.emailTxt"
                                [(ngModel)]="formGa.referralCase.emailTxt"
                                (blur)="formGa.referralCase.emailTxt = formGa.referralCase.emailTxt.trim()"
                                pattern="^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,4}$"
                                maxlength="60"
                                uppercase
                                #caseVOemailTxt="ngModel"
                                [required]="emailTxtRequired"
                                email
                              />
                              <mat-error
                                *ngIf="caseVOemailTxt.errors?.['required'] && !caseVOemailTxt.errors?.['nomatch']"
                                >Email Address is required</mat-error
                              >
                              <mat-error
                                *ngIf="caseVOemailTxt.errors?.['invalid']"
                                >Email Address is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="caseVOemailTxt.errors?.['email'] && !caseVOemailTxt.errors?.['pattern']"
                                >Email Address is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="caseVOemailTxt.errors?.['pattern']"
                                >Email Address format should be
                                name&#64;example.com</mat-error
                              >
                            </mat-form-field>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col">
                            <section class="example-section">
                              <mat-slide-toggle
                                color="primary"
                                class="example-margin"
                                name="sendInformationCheck"
                                [(ngModel)]="formGa.referralCase.emailSignup"
                                (change)="checkEmail($event)"
                                #sendInformationChecked="ngModel"
                                >Please slide this toggle if you consent to receiving email communications from the GA HIPP Unit.</mat-slide-toggle
                              >
                            </section>
                            <mat-error
                              *ngIf="sendInformationChecked.errors?.['required'] && customerForm.submitted"
                              >Your response is required</mat-error
                            >
                          </div>
                        </div>
                      </mat-card-content>
                    </mat-card>
                    <br />
                    <mat-card class="mat-elevation-z4">
                      <mat-card-header>
                        <mat-card-subtitle
                          ><strong
                            >Residential Address</strong
                          ></mat-card-subtitle
                        >
                      </mat-card-header>
                      <mat-card-content>
                        <br />
                        <div class="row">
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >Residential Address<ng-container
                                  *ngIf="!resAddress1Required"
                                  >*</ng-container
                                ></mat-label
                              >
                              <input matInput #residentialAddress type="text" name="caseVO.addressLine1Txt" autocomplete="off" #trigger="matAutocompleteTrigger"
                              placeholder="Enter your address" [formControl]="resAddressFormControl.controls.address1Txt"
                              (blur)="validateAddress(resAddressFormControl.controls.address1Txt, resAddressFormControl.controls.cityTxt, resAddressFormControl.controls.stateCd, resAddressFormControl.controls.zipCd)"
                              [required]="resAddress1Required"
                              (keyup)="setDefaultBlank($event,residentialAddress.name, resAddressFormControl,'resAddress')"
                               uppercase  maxlength="50"  [matAutocomplete]="auto" />
                               <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption
                               (optionSelected)="selectSuggestion(resAddressFormControl, residentialAddress.name, resAddressFormControl.controls.address1Txt, $event, trigger, 'resAddress')">
                                 <mat-option *ngFor="let suggestion of addressSuggestions.resAddress" [value]="suggestion">
                                   {{ suggestion.street_line }} {{ suggestion.secondary }} {{ suggestion.city }} {{ suggestion.state }} {{ suggestion.zipcode }}
                                   <span *ngIf="suggestion.entries>'1'" class="sub-address">+{{suggestion.entries}} addresses ></span>
                                 </mat-option>
                               </mat-autocomplete>
                             <mat-error *ngIf="resAddressFormControl.controls.address1Txt.errors?.['required']">Address is required</mat-error>
                             <mat-error *ngIf="resAddressFormControl.controls.address1Txt.errors?.['invalid']">Enter valid Address</mat-error>
                             <mat-error *ngIf="resAddressFormControl.controls.address1Txt.errors?.['po']">PO box is not allowed in residential address</mat-error>
                             <mat-error *ngIf="resAddressFormControl.controls.address1Txt.errors?.['nomatch']">Only AlphaNumeric and space are
                               allowed</mat-error>
                             <mat-error *ngIf="resAddressFormControl.controls.address1Txt.errors?.['pattern']" >Only AlphaNumeric and space are allowed</mat-error >
                           </mat-form-field>
                          </div>
                          <div class="col" *ngIf="showResAddress">
                            <mat-form-field appearance="outline">
                              <mat-label>Apartment/Lot</mat-label>
                              <input
                                matInput
                                type="text"
                                [formControl]="resAddressFormControl.controls.address2Txt" uppercase maxlength="50"
                                readonly />
                              <mat-error
                                *ngIf="resAddressFormControl.controls.address2Txt.errors?.['required']"
                                >Address2 is required</mat-error
                              >
                              <mat-error *ngIf="resAddressFormControl.controls.address2Txt.errors?.['invalid']"
                                >Address2 is invalid</mat-error
                              >
                              <mat-error *ngIf="resAddressFormControl.controls.address2Txt.errors?.['nomatch']"
                                >Only Alphabetical, Space, Hyphen, and
                                Apostrophe are allowed.</mat-error
                              >
                            </mat-form-field>
                          </div>
                        </div>
                        <br *ngIf="showResAddress" />
                        <div *ngIf="showResAddress" class="row">
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >City<ng-container *ngIf="!resCityRequired"
                                  >*</ng-container
                                ></mat-label
                              >
                              <input
                                matInput
                                type="text"
                                name="caseVO.cityTxt"
                                [formControl]="resAddressFormControl.controls.cityTxt"
                                [required]="resCityRequired"
                                uppercase
                                maxlength="50"
                                [readonly]="true"
                              />
                              <mat-error
                                *ngIf="resAddressFormControl.controls.cityTxt.errors?.['required']"
                                >City is required</mat-error
                              >
                              <mat-error
                                *ngIf="resAddressFormControl.controls.cityTxt.errors?.['invalid']"
                                >City is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="resAddressFormControl.controls.cityTxt.errors?.['pattern']"
                                >City is invalid</mat-error
                              >
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field
                              appearance="outline"
                              class="disableformfiled"
                            >
                              <mat-label class="disableLableColor"
                                >State<ng-container *ngIf="!resStateRequired"
                                  >*</ng-container
                                ></mat-label
                              >
                              <select
                                matNativeControl
                                style="color: rgba(0, 0, 0, 0.87)"
                                name="caseVO.stacdRf"
                                [required]="resStateRequired"

                                aria-label="Default select example"
                                [formControl]="resAddressFormControl.controls.stateCd" >

                                <ng-container
                                  *ngIf="preference.dropDownValues != null"
                                >
                                  <option
                                    *ngFor="
                                      let state of preference.dropDownValues[
                                        'STATECD'
                                      ] | keyvalue : originalOrder
                                    "
                                    [value]="state.key"
                                  >
                                    {{ state.value }}
                                  </option>
                                </ng-container>
                              </select>
                              <mat-error
                                *ngIf="resAddressFormControl.controls.stateCd.errors?.['required']"
                                >State is required</mat-error
                              >
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >Zip Code<ng-container *ngIf="!resZipRequired"
                                  >*</ng-container
                                ></mat-label
                              >
                              <input
                                matInput
                                type="text"
                                name="caseVO.zip5Cd"
                                maxlength="10"
                                minlength="5"
                                [formControl]="resAddressFormControl.controls.zipCd" readonly pattern="(^\d{5}$)|(^\d{5}-\d{4}$)"
                                [required]="resZipRequired" />

                              <mat-error
                                *ngIf="resAddressFormControl.controls.zipCd.errors?.['required']"
                                >Zip Code is required</mat-error
                              >
                              <mat-error
                                *ngIf="resAddressFormControl.controls.zipCd.errors?.['invalid']"
                                >Zip Code is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="resAddressFormControl.controls.zipCd.errors?.['pattern']"
                                >Zip Code is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="resAddressFormControl.controls.zipCd.errors?.['nomatch']"
                                >Only numerical values are allowed</mat-error
                              >
                            </mat-form-field>
                          </div>
                        </div>
                      </mat-card-content>
                    </mat-card>

                    <br />
                    <div class="row">
                      <div class="col">
                        <mat-label
                          >Is physical and mailing address the same?
                          <span class="text-danger">*</span></mat-label
                        >

                        <mat-radio-group
                          #group
                          color="primary"
                          aria-label="Select an option"
                          [(ngModel)]="isSameMailingAddress"
                          [required]="isSameRequired"
                          name="isSameMailingAddress"
                          #isSameMailing="ngModel"
                          (click)="sameMailingAddress()"
                        >
                          <mat-radio-button
                            value="Yes"
                          >
                            Yes
                          </mat-radio-button>
                          <mat-radio-button
                            value="No"
                            
                          >
                            No
                          </mat-radio-button>
                        </mat-radio-group>
                      </div>
                      <mat-error
                        *ngIf="isSameMailing.errors?.['required'] && customerForm.submitted"
                        >Your response is required</mat-error
                      >
                    </div>
                    <br />
                    <mat-card
                      *ngIf="isSameMailingAddress == 'No'"
                      class="mat-elevation-z4"
                    >
                      <mat-card-header>
                        <mat-card-subtitle
                          ><strong>Mailing Address</strong></mat-card-subtitle
                        >
                      </mat-card-header>
                      <mat-card-content>
                        <br />
                        <div *ngIf="isSameMailingAddress == 'No'" class="row">
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >Mailing Address<ng-container
                                  *ngIf="!mailAddress1Required"
                                  >*</ng-container
                                ></mat-label
                              >
                              <input matInput #mailingAddress type="text" name="mailAddress.addressLine1Txt" autocomplete="off" #trigger1="matAutocompleteTrigger"
                              (keyup)="setDefaultBlank($event,mailingAddress.name, mailAddressFormControl, 'mailAddress')" placeholder="Enter your address"
                              (focus)="onFocusInput()" [required]="mailAddress1Required"
                              (blur)="validateAddress(mailAddressFormControl.controls.address1Txt, mailAddressFormControl.controls.cityTxt, mailAddressFormControl.controls.stateCd, mailAddressFormControl.controls.zipCd)"
                              [formControl]="mailAddressFormControl.controls.address1Txt"
                               uppercase maxlength="50"  [matAutocomplete]="auto" />
                               <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption
                               (optionSelected)="selectSuggestion(mailAddressFormControl, mailingAddress.name, mailAddressFormControl.controls.address1Txt, $event, trigger1, 'mailAddress')">
                                 <mat-option *ngFor="let suggestion of addressSuggestions.mailAddress" [value]="suggestion">
                                   {{ suggestion.street_line }} {{ suggestion.secondary }} {{ suggestion.city }} {{ suggestion.state }} {{ suggestion.zipcode }}
                                   <span *ngIf="suggestion.entries>'1'" class="sub-address">+{{suggestion.entries}} addresses ></span>
                                 </mat-option>
                               </mat-autocomplete>
                               <mat-error *ngIf="mailAddressFormControl.controls.address1Txt.errors?.['required']">Address is required</mat-error>
                               <mat-error *ngIf="mailAddressFormControl.controls.address1Txt.errors?.['invalid']">Enter valid Address</mat-error>
                               <mat-error *ngIf="mailAddressFormControl.controls.address1Txt.errors?.['nomatch']">Only AlphaNumeric and space are
                               allowed</mat-error>
                           </mat-form-field>
                          </div>
                          <div class="col" *ngIf="showMailAddress">
                            <mat-form-field appearance="outline">
                              <mat-label>Apartment/Lot</mat-label>
                                <input
                                matInput
                                type="text"
                                name="mailAddress.addressLine2Txt"
                                [formControl]="mailAddressFormControl.controls.address2Txt" uppercase maxlength="50"
                                readonly />
                              <mat-error *ngIf="mailAddressFormControl.controls.address2Txt.errors?.['required']">Address2 is required</mat-error>
                              <mat-error *ngIf="mailAddressFormControl.controls.address2Txt.errors?.['invalid']">Address2 is invalid</mat-error>
                              <mat-error *ngIf="mailAddressFormControl.controls.address2Txt.errors?.['nomatch']">Only Alphabetical, Space, Hyphen, and Apostrophe are allowed.</mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                        <br />
                        <div
                          *ngIf="
                            isSameMailingAddress == 'No' && showMailAddress
                          "
                          class="row"
                        >
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >City<ng-container *ngIf="!mailCityRequired"
                                  >*</ng-container
                                ></mat-label
                              >
                              <input
                                matInput
                                type="text"
                                [formControl]="mailAddressFormControl.controls.cityTxt"
                                [required]="mailCityRequired" uppercase  maxlength="50"
                                readonly />
                              <mat-error *ngIf="mailAddressFormControl.controls.cityTxt.errors?.['required']">City is required</mat-error>
                              <mat-error *ngIf="mailAddressFormControl.controls.cityTxt.errors?.['invalid']">City is invalid</mat-error>
                              <mat-error *ngIf="mailAddressFormControl.controls.cityTxt.errors?.['pattern']">City is invalid</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field
                              appearance="outline"
                              class="disableformfiled"
                            >
                              <mat-label class="disableLableColor"
                                >State<ng-container *ngIf="!mailStateRequired"
                                  >*</ng-container
                                ></mat-label
                              >
                              <select
                                matNativeControl
                                style="color: rgba(0, 0, 0, 0.87)"
                                name="mailAddress.stacdRf"
                                [required]="mailStateRequired"
                                aria-label="Default select example"
                                [formControl]="mailAddressFormControl.controls.stateCd">
                                disabled
                              >
                                <ng-container
                                  *ngIf="preference.dropDownValues != null"
                                >
                                  <option
                                    *ngFor="
                                      let state of preference.dropDownValues[
                                        'STATECD'
                                      ] | keyvalue : originalOrder
                                    "
                                    [value]="state.key"
                                  >
                                    {{ state.value }}
                                  </option>
                                </ng-container>
                              </select>
                              <mat-error
                              *ngIf="mailAddressFormControl.controls.stateCd.errors?.['required']"
                              >State is required</mat-error
                            >
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >Zip Code<ng-container *ngIf="!mailZipRequired"
                                  >*</ng-container
                                ></mat-label
                              >
                              <input
                                matInput
                                type="text"
                                name="mailing.zip5Cd"
                                maxlength="10"
                                minlength="5"
                                [formControl]="mailAddressFormControl.controls.zipCd" pattern="(^\d{5}$)|(^\d{5}-\d{4}$)"
                                 [required]="mailZipRequired" readonly />
                              <mat-error *ngIf="mailAddressFormControl.controls.zipCd.errors?.['required']">Zip Code is required</mat-error>
                              <mat-error *ngIf="mailAddressFormControl.controls.zipCd.errors?.['invalid']">Zip Code is invalid</mat-error>
                              <mat-error *ngIf="mailAddressFormControl.controls.zipCd.errors?.['pattern']">Zip Code is invalid</mat-error>
                              <mat-error *ngIf="mailAddressFormControl.controls.zipCd.errors?.['nomatch']">Only numerical values are
                                allowed</mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      </mat-card-content>
                    </mat-card>

                    <br />
                  </div>

                  <div
                    class="d-grid gap-2 d-md-flex justify-content-md-end"
                    *ngIf="existingMember != null"
                  >
                    <button
                      id="firstStepNextButton"
                      mat-raised-button
                      color="primary"
                      (click)="forward()"
                    >
                      Next
                    </button>
                    
                  </div>
                </fieldset>
              </mat-step>
              <mat-step
                label="Employer/Policy"
                [completed]="employerPolicyCheck()"
              >
                <fieldset
                  class="shadow p-5 mb-1 rounded-5"
                  style="border: 2px solid #63b1bc"
                >
                  <legend
                    class="float-none w-auto p-1 mx-5 fw-bold fs-1"
                    style="color: #0f6db7"
                  >
                  <ng-container *ngIf="existingMember == 'Yes'">Update Now</ng-container>
                  <ng-container *ngIf="existingMember != 'Yes'">Apply Now</ng-container>
                  </legend>
                  <div class="row">
                    <div class="col"></div>
                  </div>
                  <mat-card class="mat-elevation-z4">
                    <mat-card-header>
                      <mat-card-subtitle
                        ><label
                          ><strong>
                            Tell us about the employer or insurance company that
                            offers health insurance or COBRA coverage.
                          </strong>
                        </label></mat-card-subtitle
                      >
                    </mat-card-header>
                    <mat-card-content>
                      <br />
                      <div class="row">
                        <div class="col">
                          <mat-label
                            >Is this health insurance through?<span
                              class="text-danger"
                              >*</span
                            ></mat-label
                          >

                          <mat-radio-group
                            #group
                            color="primary"
                            aria-label="Select an option"
                            [(ngModel)]="formGa.referralPolicy.policySourceCd"
                            #sourceCd="ngModel"
                            name="isHealthInsurance"
                            [required]="sourceCdRequired"
                          >
                            <mat-radio-button
                              value="E"
                              [required]="sourceCdRequired"
                            >
                              Employer
                            </mat-radio-button>
                            <mat-radio-button
                              value="C"
                              [required]="sourceCdRequired"
                            >
                              Cobra
                            </mat-radio-button>
                            <mat-radio-button
                              value="O"
                              [required]="sourceCdRequired"
                            >
                              Other
                            </mat-radio-button>
                          </mat-radio-group>
                          <mat-error
                            *ngIf="sourceCd.errors?.['required'] && customerForm.submitted"
                            >Your response is required</mat-error
                          >
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >Employer or Company Name<ng-container
                                *ngIf="!eplyrNmRequired"
                                >*</ng-container
                              ></mat-label
                            >
                            <input
                              matInput
                              type="text"
                              name="employerVO.emplyrNm"
                              [(ngModel)]="formGa.referralEmployer.emplyrNm"
                              maxlength="100"
                              uppercase
                              pattern="^(?![ -\/]).+"
                              [required]="eplyrNmRequired"
                              (keypress)="allowAlphaNumericWithSplChar($event)"
                              #emplyrNm="ngModel"
                            />
                            <mat-error *ngIf="emplyrNm.errors?.['required']"
                              >Employer Name is required</mat-error
                            >
                            <mat-error *ngIf="emplyrNm.errors?.['pattern']"
                              >Employer Name is invalid</mat-error
                            >
                          </mat-form-field>
                        </div>
                        <div class="col-4">
                          <mat-form-field appearance="outline">
                            <mat-label>Fax Number</mat-label>
                            <input
                              matInput
                              type="text"
                              name="employerVO.faxNum"
                              [(ngModel)]="formGa.referralEmployer.faxNum"
                              maxlength="12"
                              pattern="^\d{3}-\d{3}-\d{4}$"
                              (input)="
                                formGa.referralEmployer.faxNum = phonemask2(
                                  $event,
                                  faxNum
                                )
                              "
                              (blur)="phoneCheck($event, faxNum)"
                              (keypress)="isNumeric($event, faxNum)"
                              #faxNum="ngModel"
                            />
                            <mat-error *ngIf="faxNum.errors?.['minlength']"
                              >Fax Number is invalid</mat-error
                            >
                            <mat-error *ngIf="faxNum.errors?.['invalid']"
                              >Fax Number is invalid</mat-error
                            >
                            <mat-error *ngIf="faxNum.errors?.['required'] && !faxNum.errors?.['nomatch']"
                              >Fax Number is required</mat-error
                            >
                            <mat-error *ngIf="faxNum.errors?.['pattern']"
                              >Fax Number is invalid</mat-error
                            >
                            <mat-error *ngIf="faxNum.errors?.['nomatch']"
                              >Only numerical values are allowed</mat-error
                            >
                          </mat-form-field>
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >Address<ng-container
                                *ngIf="!emplyrAddr1Required"
                                >*</ng-container
                              ></mat-label
                            >
                            <input matInput type="text" #emplyrAddress name="employerVO.addressLine1Txt" autocomplete="off" #trigger2="matAutocompleteTrigger"
                              (focus)="onFocusInput()"
                                (keyup)="setDefaultBlank($event, emplyrAddress.name, referralEmployerAddressFormControl, 'referralEmployerAddress')"
                                placeholder="Enter your address" [required]="emplyrAddr1Required"
                                [formControl]="referralEmployerAddressFormControl.controls.address1Txt"
                                (blur)="validateAddress(referralEmployerAddressFormControl.controls.address1Txt, referralEmployerAddressFormControl.controls.cityTxt, referralEmployerAddressFormControl.controls.stateCd, referralEmployerAddressFormControl.controls.zipCd)"
                                uppercase  maxlength="50"  [matAutocomplete]="auto2" />
                                  <mat-autocomplete #auto2="matAutocomplete"  autoActiveFirstOption
                                  (optionSelected)="selectSuggestion(referralEmployerAddressFormControl, emplyrAddress.name, referralEmployerAddressFormControl.controls.address1Txt, $event, trigger2, 'referralEmployerAddress')">
                                    <mat-option *ngFor="let suggestion of addressSuggestions.referralEmployerAddress" [value]="suggestion">
                                      {{ suggestion.street_line }} {{ suggestion.secondary }} {{ suggestion.city }} {{ suggestion.state }} {{ suggestion.zipcode }}
                                      <span *ngIf="suggestion.entries>'1'" class="sub-address">+{{suggestion.entries}} addresses ></span>
                                    </mat-option>
                                  </mat-autocomplete>
                            <mat-error *ngIf="referralEmployerAddressFormControl.controls.address1Txt.errors?.['required']">Employer Address is required</mat-error>
                            <mat-error *ngIf="referralEmployerAddressFormControl.controls.address1Txt.errors?.['invalid']">Enter valid Address</mat-error>
                          </mat-form-field>
                        </div>
                        <div class="col-4" *ngIf="showEmployerAddress">
                          <mat-form-field appearance="outline">
                            <mat-label>Suite/Unit</mat-label>
                            <input
                              matInput
                              type="text"
                              name="employerVO.addressLine2Txt"
                              readonly
                              [formControl]="referralEmployerAddressFormControl.controls.address2Txt" uppercase maxlength="40"
                              readonly />
                            <mat-error *ngIf="referralEmployerAddressFormControl.controls.address2Txt.errors?.['required']">Employer Suite/Unit is
                              required</mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <br *ngIf="showEmployerAddress" />
                      <div class="row" *ngIf="showEmployerAddress">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >City<ng-container
                                *ngIf="
                                  existingMember == 'No' && !emplyrCityRequired
                                "
                                >*</ng-container
                              ></mat-label
                            >
                              <input matInput type="text" name="employerVO.cityTxt" [required]="emplyrCityRequired"
                              [formControl]="referralEmployerAddressFormControl.controls.cityTxt" uppercase
                                maxlength="20" readonly />
                              <mat-error *ngIf="referralEmployerAddressFormControl.controls.cityTxt.errors?.['invalid']">City is invalid</mat-error>
                              <mat-error *ngIf="referralEmployerAddressFormControl.controls.cityTxt.errors?.['pattern']">City is invalid</mat-error>
                              <mat-error *ngIf="referralEmployerAddressFormControl.controls.cityTxt.errors?.['required']">City is required</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field
                            appearance="outline"
                            class="disableformfiled"
                          >
                            <mat-label class="disableLableColor"
                              >State<ng-container
                                *ngIf="
                                  existingMember == 'No' && !emplyrStateRequired
                                "
                                >*</ng-container
                              ></mat-label
                            >
                            <select
                              matNativeControl
                              style="color: rgba(0, 0, 0, 0.87)"
                              name="employerVO.stacdRf"
                              [formControl]="referralEmployerAddressFormControl.controls.stateCd" aria-label="Default select example"
                              [required]="emplyrStateRequired" [disabled]="true">

                              <ng-container
                                *ngIf="preference.dropDownValues != null"
                              >
                                <option
                                  *ngFor="
                                    let state of preference.dropDownValues[
                                      'STATECD'
                                    ] | keyvalue : originalOrder
                                  "
                                  [value]="state.key"
                                >
                                  {{ state.value }}
                                </option>
                              </ng-container>
                            </select>
                            <mat-error *ngIf="referralEmployerAddressFormControl.controls.stateCd.errors?.['required']">State is required</mat-error>
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >Zip Code<ng-container
                                *ngIf="
                                  existingMember == 'No' &&
                                  !emplyrZipCodeRequired
                                "
                                >*</ng-container
                              ></mat-label
                            >
                            <input
                              matInput
                              type="text"
                              name="employerVO.zip5Cd"
                              [formControl]="referralEmployerAddressFormControl.controls.zipCd" minlength="5" maxlength="10"
                              [required]="emplyrZipCodeRequired" pattern="(^\d{5}$)|(^\d{5}-\d{4}$)"
                               readonly />
                            <mat-error *ngIf="referralEmployerAddressFormControl.controls.zipCd.errors?.['invalid']">Zip Code is invalid</mat-error>
                            <mat-error *ngIf="referralEmployerAddressFormControl.controls.zipCd.errors?.['pattern']">Zip Code is invalid</mat-error>
                            <mat-error *ngIf="referralEmployerAddressFormControl.controls.zipCd.errors?.['required']">Zip Code is
                              required</mat-error>
                            <mat-error *ngIf="referralEmployerAddressFormControl.controls.zipCd.errors?.['nomatch']">Only numerical values are
                              allowed</mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >Human Resources Contact Name<ng-container
                                *ngIf="!hrContactNameRequired"
                                >*</ng-container
                              ></mat-label
                            >
                            <input
                              matInput
                              type="text"
                              name="employerVO.hrContactName"
                              [(ngModel)]="formGa.referralEmployer.hrContactName"
                              maxlength="100"
                              uppercase
                              pattern="^[a-zA-Z](?!.*--)(?!.*-')(?!.* ')(?!.*'-)(?!.*' )(?!.* -)(?!.*- )(?!.*  )(?!.*'')[a-zA-Z \-']+$"
                              [required]="hrContactNameRequired"
                              (keypress)="allowAlphabets2($event, hrContactName)"
                              #hrContactName="ngModel"
                            />
                            <mat-error *ngIf="hrContactName.errors?.['required']"
                              >Human Resources Contact Name is required</mat-error
                            >
                            <mat-error *ngIf="hrContactName.errors?.['pattern']"
                              >Human Resources Contact Name is invalid</mat-error
                            >
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Employer Email</mat-label>
                            <input
                              matInput
                              type="text"
                              name="employerVO.emailTxt"
                              [(ngModel)]="formGa.referralEmployer.emailTxt"
                              (blur)="formGa.referralEmployer.emailTxt = formGa.referralEmployer.emailTxt?.trim()"
                              maxlength="60"
                              uppercase
                              #employerEmailTxt="ngModel"
                              email
                            />
                            <mat-error *ngIf="employerEmailTxt.errors?.['email']"
                              >Employer Email is invalid</mat-error
                            >
                          </mat-form-field>
                        </div>
                        <div class="col-4">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >Human Resources Contact Number<ng-container
                                *ngIf="!emplyrPhoneRequired"
                                >*</ng-container
                              ></mat-label
                            >
                            <input
                              matInput
                              type="text"
                              name="employerVO.phone1Num"
                              [(ngModel)]="formGa.referralEmployer.phoneNum"
                              maxlength="12"
                              pattern="^\d{3}-\d{3}-\d{4}$"
                              [required]="emplyrPhoneRequired"
                              (input)="
                                formGa.referralEmployer.phoneNum = phonemask2(
                                  $event,
                                  employerDTOphone1Num
                                )
                              "
                              (blur)="phoneCheck($event, employerDTOphone1Num)"
                              (keypress)="
                                isNumeric($event, employerDTOphone1Num)
                              "
                              #employerDTOphone1Num="ngModel"
                            />
                            <mat-error
                              *ngIf="employerDTOphone1Num.errors?.['invalid']"
                              >Human Resources Contact Number is invalid</mat-error
                            >
                            <mat-error
                              *ngIf="employerDTOphone1Num.errors?.['pattern']"
                              >Human Resources Contact Number is invalid</mat-error
                            >
                            <mat-error
                              *ngIf="employerDTOphone1Num.errors?.['minlength']"
                              >Human Resources Contact Number is invalid</mat-error
                            >
                            <mat-error
                              *ngIf="employerDTOphone1Num.errors?.['required'] && !employerDTOphone1Num.errors?.['nomatch']"
                              >Human Resources Contact Number is required</mat-error
                            >
                            <mat-error
                              *ngIf="employerDTOphone1Num.errors?.['nomatch']"
                              >Only numerical values are allowed</mat-error
                            >
                          </mat-form-field>
                        </div>
                        
                      </div>
                      <br />
                      <div class="row">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >Employer FEIN (Tax ID)<ng-container
                                *ngIf="!emplyrFeinRequired"
                                >*</ng-container
                              ></mat-label
                            >
                            <input
                              matInput
                              type="text"
                              name="employerVO.emplyrFein"
                              [(ngModel)]="formGa.referralEmployer.emplyrFein"
                              minlength="10"
                              maxlength="10"
                              (keypress)="isNumeric($event, empFEINValue)"
                              (input)="
                                formGa.referralEmployer.emplyrFein =
                                  empFEINMask($event, empFEINValue)
                              "
                              pattern="(^\d{2}-\d{7}$)"
                              #empFEINValue="ngModel"
                              [required]="emplyrFeinRequired"
                              (blur)="isFEINValidValue($event, empFEINValue)"
                            />
                            <mat-error *ngIf="empFEINValue.errors?.['invalid']"
                              >Employer FEIN is invalid</mat-error
                            >
                            <mat-error *ngIf="empFEINValue.errors?.['required'] && !empFEINValue.errors?.['nomatch']"
                              >Employer FEIN is required</mat-error
                            >
                            <mat-error *ngIf="empFEINValue.errors?.['pattern']"
                              >Employer FEIN is invalid</mat-error
                            >
                            <mat-error *ngIf="empFEINValue.errors?.['nomatch']"
                              >Only numerical values are allowed</mat-error
                            >
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >Next Open Enrollment Start Date<ng-container
                                *ngIf="!emplyrErollDateRequired"
                                >*</ng-container
                              ></mat-label
                            >
                            <input
                              matInput
                              [matDatepicker]="picker8"
                              name="d8"
                              #c8="ngModel"
                              [(ngModel)]="employerErollStartDate"
                              [min]="today"
                              [max]="plus1year"
                              minlength="8"
                              maxlength="10"
                              placeholder="MMDDYYYY"
                              (input)="datemask2($event, c8)"
                              (blur)="parseDate($event, c8)"
                              (ngModelChange)="compareDate(c8, c9)"
                              (keypress)="onlyNumeric($event, c8)"
                              [required]="emplyrErollDateRequired"
                            />

                            <mat-datepicker-toggle
                              matIconSuffix
                              [for]="picker8"
                            ></mat-datepicker-toggle>
                            <mat-datepicker #picker8></mat-datepicker>

                            <mat-error *ngIf="c8.errors?.['invalid']"
                              >Enrollment start date is invalid</mat-error
                            >
                            <mat-error *ngIf="c8.errors?.['matDatepickerMin']"
                              >Enrollment start date is out of range</mat-error
                            >
                            <mat-error *ngIf="c8.errors?.['matDatepickerMax']"
                              >Enrollment start date is out of range</mat-error
                            >
                            <mat-error *ngIf="c8.errors?.['required'] && !c8.errors?.['nomatch']"
                              >Enrollment start date is required</mat-error
                            >
                            <mat-error *ngIf="c8.errors?.['nomatch']"
                              >Only numerical values are allowed</mat-error
                            >
                            <mat-error *ngIf="c8.errors?.['invalidDate']"
                              >Enrollment start date is invalid</mat-error
                            >
                            <mat-error *ngIf="c8.errors?.['invalidEndDate']"
                              >Enrollment start date should not be greater than
                              end date</mat-error
                            >
                           
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >Next Open Enrollment End Date<ng-container
                                *ngIf="!emplyrErollEndDateRequired"
                                >*</ng-container
                              ></mat-label
                            >
                            <input
                              matInput
                              [matDatepicker]="picker9"
                              name="d9"
                              #c9="ngModel"
                              [(ngModel)]="employerErollEndDate"
                              [min]="today"
                              [max]="plus1year"
                              minlength="8"
                              maxlength="10"
                              placeholder="MMDDYYYY"
                              (input)="datemask2($event, c9)"
                              (blur)="parseDate($event, c9)"
                              (ngModelChange)="compareDate(c9, c8)"
                              (keypress)="onlyNumeric($event, c9)"
                              [required]="emplyrErollEndDateRequired"
                            />

                            <mat-datepicker-toggle
                              matIconSuffix
                              [for]="picker9"
                            ></mat-datepicker-toggle>
                            <mat-datepicker #picker9></mat-datepicker>

                            <mat-error *ngIf="c9.errors?.['invalid']"
                              >Enrollment end date is invalid</mat-error
                            >
                            <mat-error *ngIf="c9.errors?.['matDatepickerMin']"
                              >Enrollment end date is out of range</mat-error
                            >
                            <mat-error *ngIf="c9.errors?.['matDatepickerMax']"
                              >Enrollment end date is out of range</mat-error
                            >
                            <mat-error *ngIf="c9.errors?.['nomatch']"
                              >Only numerical values are allowed</mat-error
                            >
                            <mat-error *ngIf="c9.errors?.['invalidDate']"
                              >Enrollment end date is invalid</mat-error
                            >
                            <mat-error *ngIf="c9.errors?.['invalidEndDate']"
                              >Enrollment end date should not be less than start
                              date</mat-error
                            >
                            <mat-error *ngIf="c9.errors?.['required'] && !c9.errors?.['nomatch']"
                              >Enrollment end date is required</mat-error
                            >
                          </mat-form-field>
                        </div>
                      </div>
                      <br />
                    </mat-card-content>
                  </mat-card>
                  <br />

                  <mat-card class="mat-elevation-z4">
                    <mat-card-header>
                      <mat-card-subtitle
                        ><label
                          ><strong>
                            Tell us about the health insurance or COBRA plan
                            that the Policyholder is currently enrolled in or
                            has access to.
                          </strong>
                        </label>
                      </mat-card-subtitle>
                    </mat-card-header>
                    <mat-card-content>
                      <br />
                      <div class="row">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Health Insurance Company Name<ng-container
                              *ngIf="!policyNmRequired"
                              >*</ng-container
                            ></mat-label>
                            <input
                              matInput
                              type="text"
                              name="policyVO.carrierNm"
                              [(ngModel)]="formGa.referralPolicy.carrierNm"
                              uppercase
                              maxlength="40"
                              (keypress)="allowAlphaNumericForCarrier($event,policyVOcarrierNm)"
                              (blur)="validateCarrierNm($event,policyVOcarrierNm)"
                              #policyVOcarrierNm="ngModel"
                              [required]="policyNmRequired"
                            />
                            <mat-error
                              *ngIf="policyVOcarrierNm.errors?.['required']"
                              >Company name is required</mat-error
                            >
                            <mat-error
                              *ngIf="policyVOcarrierNm.errors?.['nomatch']"
                              >This field only allows - ( ) / space, alphanumeric characters and cannot end with a special character or space</mat-error
                            >
                          </mat-form-field>
                        </div>
                        <div class="col-4">
                          <mat-form-field appearance="outline">
                            <mat-label>Contact Number<ng-container
                              *ngIf="!policyPhoneRequired"
                              >*</ng-container
                            ></mat-label>
                            <input
                              matInput
                              type="text"
                              name="policyVO.phone1Num"
                              [(ngModel)]="formGa.referralPolicy.phoneNum"
                              maxlength="12"
                              pattern="^\d{3}-\d{3}-\d{4}$"
                              [required]="policyPhoneRequired"
                              (input)="
                                formGa.referralPolicy.phoneNum = phonemask2(
                                  $event,
                                  policyVoPhoneNum
                                )
                              "
                              (blur)="phoneCheck($event, policyVoPhoneNum)"
                              (keypress)="isNumeric($event, policyVoPhoneNum)"
                              #policyVoPhoneNum="ngModel"
                            />
                            <mat-error
                              *ngIf="policyVoPhoneNum.errors?.['invalid']"
                              >Contact Number is invalid</mat-error
                            >
                            <mat-error
                              *ngIf="policyVoPhoneNum.errors?.['pattern']"
                              >Contact Number is invalid</mat-error
                            >
                            <mat-error
                              *ngIf="policyVoPhoneNum.errors?.['minlength']"
                              >Contact Number is invalid</mat-error
                            >
                            <mat-error
                              *ngIf="policyVoPhoneNum.errors?.['required'] && !policyVoPhoneNum.errors?.['nomatch']"
                              >Contact Number is required</mat-error
                            >
                            <mat-error
                              *ngIf="policyVoPhoneNum.errors?.['nomatch']"
                              >Only numerical values are allowed</mat-error
                            >
                          </mat-form-field>
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >Health Insurance Company Address<ng-container
                              *ngIf="!policyAddr1Required"
                              >*</ng-container
                            ></mat-label
                            >
                            <input matInput type="text" #policyAddress name="policyVO.addressLine1Txt" autocomplete="off"
                            [required]="policyAddr1Required"
                            (keyup)="setDefaultBlank($event, policyAddress.name, referralPolicyAddressFormControl,'referralPolicyAddress')"
                            placeholder="Enter your address" #trigger3="matAutocompleteTrigger"
                            [formControl]="referralPolicyAddressFormControl.controls.address1Txt"
                            (blur)="validateAddress(referralPolicyAddressFormControl.controls.address1Txt, referralPolicyAddressFormControl.controls.cityTxt, referralPolicyAddressFormControl.controls.stateCd, referralPolicyAddressFormControl.controls.zipCd)"
                             uppercase maxlength="50"  [matAutocomplete]="auto1" />

                              <mat-autocomplete #auto1="matAutocomplete" autoActiveFirstOption
                              (optionSelected)="selectSuggestion(referralPolicyAddressFormControl, policyAddress.name, referralPolicyAddressFormControl.controls.address1Txt, $event, trigger3,'referralPolicyAddress')">
                                <mat-option *ngFor="let suggestion of addressSuggestions.referralPolicyAddress" [value]="suggestion">
                                  {{ suggestion.street_line }} {{ suggestion.secondary }} {{ suggestion.city }} {{ suggestion.state }} {{ suggestion.zipcode }}
                                  <span *ngIf="suggestion.entries>'1'" class="sub-address">+{{suggestion.entries}} addresses ></span>
                                </mat-option>
                              </mat-autocomplete>
                            <mat-error *ngIf="referralPolicyAddressFormControl.controls.address1Txt.errors?.['required']">Address is required</mat-error>
                            <mat-error *ngIf="referralPolicyAddressFormControl.controls.address1Txt.errors?.['invalid']">Enter valid Address</mat-error>
                            <mat-error *ngIf="referralPolicyAddressFormControl.controls.address1Txt.errors?.['nomatch']">Only AlphaNumeric and space are
                              allowed</mat-error>
                        </mat-form-field>
                        </div>
                        <div class="col-4" *ngIf="showPolicyAddress">
                          <mat-form-field appearance="outline">
                            <mat-label>Suite/Unit</mat-label>
                            <input
                              matInput
                              type="text"
                              name="policyVO.addressLine2Txt"
                              [formControl]="referralPolicyAddressFormControl.controls.address2Txt" uppercase maxlength="40" readonly />

                            <!-- <mat-error *ngIf="policyAddr2.errors?.['required']"
                              >Company Suite/Unit is required</mat-error
                            > -->
                          </mat-form-field>
                        </div>
                      </div>
                      <br *ngIf="showPolicyAddress" />
                      <div class="row" *ngIf="showPolicyAddress">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>City</mat-label>
                              <input
                              matInput
                              type="text"
                              name="policyVO.cityTxt"
                              [formControl]="referralPolicyAddressFormControl.controls.cityTxt" uppercase maxlength="40"
                              readonly />
                            <mat-error *ngIf="referralPolicyAddressFormControl.controls.cityTxt.errors?.['invalid']">City is invalid</mat-error>
                            <mat-error *ngIf="referralPolicyAddressFormControl.controls.cityTxt.errors?.['pattern']">City is invalid</mat-error>
                            <mat-error *ngIf="referralPolicyAddressFormControl.controls.cityTxt.errors?.['required']">City is required</mat-error>
                            <mat-error *ngIf="referralPolicyAddressFormControl.controls.cityTxt.errors?.['nomatch']">Only Alphabetical, Space, Hyphen, and Apostrophe are allowed.</mat-error>
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field
                            appearance="outline"
                            class="disableformfiled"
                          >
                            <mat-label class="disableLableColor"
                              >State</mat-label
                            >
                            <select
                              matNativeControl
                              style="color: rgba(0, 0, 0, 0.87)"
                              name="policyVO.stacdRf"
                              [formControl]="referralPolicyAddressFormControl.controls.stateCd" aria-label="Default select example"
                              [required]="policyStateRequired" >
                              <ng-container
                                *ngIf="preference.dropDownValues != null"
                              >
                                <option
                                  *ngFor="
                                    let state of preference.dropDownValues[
                                      'STATECD'
                                    ] | keyvalue : originalOrder
                                  "
                                  [value]="state.key"
                                >
                                  {{ state.value }}
                                </option>
                              </ng-container>
                            </select>
                            <!-- <mat-error *ngIf="policyState.errors?.['required']"
                              >State is required</mat-error
                            > -->
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Zip Code</mat-label>
                            <input
                              matInput
                              type="text"
                              name="policyVO.zip5Cd"
                              [formControl]="referralPolicyAddressFormControl.controls.zipCd"
                              minlength="5" maxlength="10" pattern="(^\d{5}$)|(^\d{5}-\d{4}$)"
                              readonly />
                            <mat-error *ngIf="referralPolicyAddressFormControl.controls.zipCd.errors?.['invalid']">Zip Code is invalid</mat-error>
                            <mat-error *ngIf="referralPolicyAddressFormControl.controls.zipCd.errors?.['pattern']">Zip Code is invalid</mat-error>
                            <mat-error *ngIf="referralPolicyAddressFormControl.controls.zipCd.errors?.['nomatch']">Only numerical values are
                              allowed</mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Health Insurance Plan Name<ng-container
                              *ngIf="!policyPlanNmRequired"
                              >*</ng-container
                            ></mat-label>
                            <input
                              matInput
                              type="text"
                              name="policyVO.planName"
                              [(ngModel)]="formGa.referralPolicy.planName"
                              maxlength="100"
                              uppercase
                              (keypress)="allowAlphaNumericWithSplChars($event,policyPlanNm)"
                              [required]="policyPlanNmRequired"
                              (blur)="validatePlanNm($event,policyPlanNm)"
                              #policyPlanNm="ngModel"
                            />
                            <mat-error *ngIf="policyPlanNm.errors?.['required']"
                              >Policy plan name is required</mat-error
                            >
                            <mat-error *ngIf="policyPlanNm.errors?.['nomatch']"
                              >This field only allows - / # & space, alphanumeric characters and cannot end with a special character or space</mat-error
                            >
                          </mat-form-field>
                        </div>
                        <div class="col-5">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >How frequent is the premium
                              paid/deducted?<ng-container
                                *ngIf="!frequencyRequired"
                                >*</ng-container
                              >
                            </mat-label>
                            <select
                              matNativeControl
                              name="policyVO.frequency"
                              [(ngModel)]="formGa.referralPolicy.frequency"
                              #frequency="ngModel"
                              aria-label="Default select example"
                              [required]="frequencyRequired"
                            >
                              <ng-container
                                *ngIf="preference.dropDownValues != null"
                              >
                                <option
                                  *ngFor="
                                    let state of preference.dropDownValues[
                                      'FRQCD'
                                    ] | keyvalue : originalOrder
                                  "
                                  [value]="state.key"
                                >
                                  {{ state.value }}
                                </option>
                              </ng-container>
                            </select>
                            <mat-error *ngIf="frequency.errors?.['required']"
                              >Frequency is required</mat-error
                            >
                          </mat-form-field>
                        </div>
                      </div>                      
                      <br />
                      <div class="row">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Policy Start Date<ng-container
                              *ngIf="!policyStartRequired"
                              >*</ng-container
                            ></mat-label>
                            <input
                              matInput
                              [matDatepicker]="picker3"
                              [min]="prev10year"
                              [max]="next5year"
                              name="d3"
                              #c3="ngModel"
                              [(ngModel)]="policyVOpolicyStartDate"
                              minlength="8"
                              maxlength="10"
                              placeholder="MMDDYYYY"
                              (input)="datemask2($event, c3)"
                              (blur)="parseDate($event, c3)"
                              (keypress)="onlyNumeric($event, c3)"
                              [required]="policyStartRequired"
                            />

                            <mat-datepicker-toggle
                              matIconSuffix
                              [for]="picker3"
                            ></mat-datepicker-toggle>
                            <mat-datepicker #picker3></mat-datepicker>
                            <mat-error *ngIf="c3.errors?.['required'] && !c3.errors?.['nomatch']"
                              >Policy start date is required</mat-error
                            >
                            <mat-error *ngIf="c3.errors?.['minlength']"
                              >Policy start date is invalid</mat-error
                            >
                            <mat-error *ngIf="c3.errors?.['invalid']"
                              >Policy start date is invalid</mat-error
                            >
                            <mat-error *ngIf="c3.errors?.['matDatepickerMin']"
                              >Policy start date out of range</mat-error
                            >
                            <mat-error *ngIf="c3.errors?.['matDatepickerMax']"
                              >Policy start date out of range</mat-error
                            >
                            <mat-error *ngIf="c3.errors?.['nomatch']"
                              >Only numerical values are allowed</mat-error
                            >
                            <mat-error *ngIf="c3.errors?.['invalidDate']"
                              >Policy start date is invalid</mat-error
                            >
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Policy ID Number<ng-container
                              *ngIf="!policyIdRequired"
                              >*</ng-container
                            ></mat-label>
                            <input
                              matInput
                              type="text"
                              name="policyVO.policyNum"
                              [(ngModel)]="formGa.referralPolicy.policyNum"
                              uppercase
                              maxlength="20"
                              (keypress)="allowAlphaNumericForPolicyId($event,policyId)"
                              [required]="policyIdRequired"
                              (blur)="validatePolicyId($event,policyId)"
                              #policyId="ngModel"
                            />
                            <mat-error *ngIf="policyId.errors?.['required']"
                              >Policy Id is required</mat-error
                            >
                            <mat-error *ngIf="policyId.errors?.['nomatch']"
                              >This field only allows - and alphanumeric characters</mat-error
                            >
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Group Number<ng-container
                              *ngIf="!policyGroupNumRequired"
                              >*</ng-container
                            ></mat-label>
                            <input
                              matInput
                              type="text"
                              name="policyVO.groupNum"
                              [(ngModel)]="formGa.referralPolicy.groupNum"
                              uppercase
                              maxlength="15"
                              (keypress)="allowAlphaNumericWithTwoSplChar($event,policyGroupNum)"
                              (blur)="validateGroupNum($event,policyGroupNum)"
                              [required]="policyGroupNumRequired"
                              #policyGroupNum="ngModel"
                            />
                            <mat-error
                              *ngIf="policyGroupNum.errors?.['required']"
                              >Policy Group Number is required</mat-error
                            >
                            <mat-error
                            *ngIf="policyGroupNum.errors?.['nomatch']"
                            >This field only allows alphanumeric characters, space, - and cannot end with a special character or space</mat-error
                          >
                          </mat-form-field>
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >Premium Amount<ng-container
                                *ngIf="!premiumAmountRequired"
                                >*</ng-container
                              ></mat-label
                            >
                            <input
                              matInput
                              type="text"
                              name="premium"
                              [(ngModel)]="
                                formGa.referralPolicy.employeePremium
                              "
                              #policyVOempyPremium="ngModel"
                              maxlength="8"
                              min="0"
                              pattern="^[0-9]{1,7}(\.[0-9]{0,2})?$"
                              (input)="
                                formGa.referralPolicy.employeePremium =
                                  amountMask($event, policyVOempyPremium)
                              "
                              (blur)="
                                validatePremiumAmount(
                                  $event,
                                  policyVOempyPremium
                                )
                              "
                              [required]="premiumAmountRequired"
                            />
                            <span matTextPrefix>$&nbsp;</span>
                            <mat-error
                              *ngIf="policyVOempyPremium.errors?.['required']"
                              >Premium Amount is required</mat-error
                            >
                            <mat-error
                              *ngIf="policyVOempyPremium.errors?.['invalid']"
                              >Premium Amount is invalid</mat-error
                            >
                            <mat-error
                              *ngIf="policyVOempyPremium.errors?.['nomatch']"
                              >Premium Amount is invalid</mat-error
                            >
                            <mat-error
                              *ngIf="policyVOempyPremium.errors?.['pattern']"
                              >Premium Amount is invalid</mat-error
                            >
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >Plan Tier<ng-container
                                *ngIf="!planTierRequired"
                                >*</ng-container
                              ></mat-label
                            >
                            <select
                              matNativeControl
                              name="policyVO.planTier"
                              [(ngModel)]="formGa.referralPolicy.planTier"
                              aria-label="Default select example"
                              [required]="planTierRequired"
                              #planTier="ngModel"
                            >
                              <ng-container
                                *ngIf="preference.dropDownValues != null"
                              >
                                <option
                                  *ngFor="
                                    let state of preference.dropDownValues[
                                      'TIERCD'
                                    ] | keyvalue : originalOrder
                                  "
                                  [value]="state.key"
                                >
                                  {{ state.value }}
                                </option>
                              </ng-container>
                            </select>
                            <mat-error *ngIf="planTier.errors?.['required']"
                              >Plan Tier is required</mat-error
                            >
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >How are premium paid ?<ng-container
                                *ngIf="!premiumPaidOptionRequired"
                                >*</ng-container
                              ></mat-label
                            >
                            <select
                              matNativeControl
                              name="policyVO.premiumPaidOption"
                              [(ngModel)]="formGa.referralPolicy.premiumPaidOption"
                              aria-label="Default select example"
                              [required]="premiumPaidOptionRequired"
                              #premiumPaidOption="ngModel"
                            >
                              <ng-container
                                *ngIf="preference.dropDownValues != null"
                              >
                                <option
                                  *ngFor="
                                    let state of preference.dropDownValues[
                                      'PREMPAIDCD'
                                    ] | keyvalue : originalOrder
                                  "
                                  [value]="state.key"
                                >
                                  {{ state.value }}
                                </option>
                              </ng-container>
                            </select>
                            <mat-error *ngIf="premiumPaidOption.errors?.['required']"
                              >Premium paid is required</mat-error
                            >
                          </mat-form-field>
                        </div>
                      </div>
                    </mat-card-content>
                  </mat-card>
                  <br />

                  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button
                      mat-raised-button
                      matStepperPrevious
                      style="background-color: #b89d18; color: white"
                      (click)="goBack()"
                    >
                      Previous
                    </button>
                    <button
                      mat-raised-button
                      color="primary"
                      matStepperNext
                      (click)="goForward()"
                    >
                      Next
                    </button>
                  </div>
                </fieldset>
              </mat-step>
              <mat-step
                label="Family Members"
                [completed]="familyMemberCheck()"
              >
                <fieldset
                  class="shadow p-5 mb-1 rounded-5"
                  style="border: 2px solid #63b1bc"
                >
                  <legend
                    class="float-none w-auto p-1 mx-5 fw-bold fs-1"
                    style="color: #0f6db7"
                  >
                  <ng-container *ngIf="existingMember == 'Yes'">Update Now</ng-container>
                  <ng-container *ngIf="existingMember != 'Yes'">Apply Now</ng-container>
                  </legend>
                  <!-- <div class="row">
                    <div class="col">
                      <mat-form-field
                        #field
                        floatLabel="always"
                        appearance="outline"
                      >
                        <mat-label class="fw-bold"
                          >Are there additional family member(s) who receive
                          Medicaid?
                          <ng-container *ngIf="!isFamilyRequired"
                            >*</ng-container
                          >
                        </mat-label>
                        <input
                          matInput
                          name="familyMemberMedicate"
                          [(ngModel)]="isFamilyMemberMedicate"
                          #familyMedicate="ngModel"
                          style="display: none"
                          [required]="isFamilyRequired"
                        />
                        <mat-radio-group
                          #group
                          color="primary"
                          aria-label="Select an option"
                          [(ngModel)]="isFamilyMemberMedicate"
                          [required]="isFamilyRequired"
                          #familyMedicate="ngModel"
                          name="familyMemberMedicate"
                          (change)="removeSavedFamilyMembers($event)"
                        >
                          <mat-radio-button
                            value="Yes"
                            [required]="isFamilyRequired"
                          >
                            Yes
                          </mat-radio-button>
                          <mat-radio-button
                            value="No"
                            [required]="isFamilyRequired"
                            
                          >
                            No
                          </mat-radio-button>
                        </mat-radio-group>
                        <mat-error
                          *ngIf="familyMedicate.errors?.['required'] && customerForm.submitted"
                          >Your response is required</mat-error
                        >
                      </mat-form-field>
                    </div>
                  </div> -->
                  <div class="row mt-3" *ngIf="!isEditingMember">
                    <div class="col">
                      <mat-form-field
                        #field
                        floatLabel="always"
                        appearance="outline"
                      >
                        <mat-label>Are there additional family member(s) who receive Medicaid?
                          <ng-container *ngIf="!isFamilyRequired">*</ng-container>
                        </mat-label>
                        <input
                          matInput
                          name="familyMemberMedicate"
                          [(ngModel)]="isFamilyMemberMedicate"
                          #familyMedicate="ngModel"
                          style="display: none"
                          [required]="isFamilyRequired"
                        />
                        <mat-radio-group
                          #group
                          color="primary"
                          aria-label="Select an option"
                          [(ngModel)]="isFamilyMemberMedicate"
                          [required]="isFamilyRequired"
                          #familyMedicate="ngModel"
                          name="familyMemberMedicate"
                          (change)="onFamilyMedicaidChange($event)"
                        >
                          <mat-radio-button
                            value="Yes"
                            [required]="isFamilyRequired"
                          >
                            Yes
                          </mat-radio-button>
                          <mat-radio-button
                            value="No"
                            [required]="isFamilyRequired"
                          >
                            No
                          </mat-radio-button>
                        </mat-radio-group>
                        <mat-error
                          *ngIf="familyMedicate.errors?.['required'] && isFamilyRequired"
                          >Your response is required</mat-error
                        >
                      </mat-form-field>
                      
                    </div>
                  </div>

                  <div *ngIf="isEditingMember || isFamilyMemberMedicate == 'Yes'">
                    <mat-card class="mat-elevation-z4">
                      <mat-card-header>
                        <mat-card-subtitle
                          ><label
                            ><strong> Add Family Members </strong>
                          </label></mat-card-subtitle
                        >
                      </mat-card-header>
                      <mat-card-content>
                        <br />
                        <div class="row">
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >First Name<ng-container
                                  *ngIf="!otherFnRequired"
                                  >*</ng-container
                                ></mat-label
                              >
                              <input
                                matInput
                                type="text"
                                name="otherfirstNm"
                                [(ngModel)]="otherfirstNm"
                                maxlength="20"
                                pattern="^[a-zA-Z](?!.*--)(?!.*-')(?!.* ')(?!.*'-)(?!.*' )(?!.* -)(?!.*- )(?!.*  )(?!.*'')[a-zA-Z \-']+$"
                                #otherFN="ngModel"
                                [required]="otherFnRequired"
                                uppercase
                                (keypress)="allowAlphabets2($event, otherFN)"
                                (blur)="nomatchCheck($event, otherFN)"
                              />
                              <mat-error *ngIf="otherFN.errors?.['required'] && !otherFN.errors?.['nomatch']"
                                >First Name is required</mat-error
                              >
                              <mat-error *ngIf="otherFN.errors?.['invalid']"
                                >First Name is invalid</mat-error
                              >
                              <mat-error *ngIf="otherFN.errors?.['pattern']"
                                >First Name is invalid</mat-error
                              >
                              <mat-error *ngIf="otherFN.errors?.['nomatch']"
                                >Only Alphabetical, Space, Hyphen and ' are allowed</mat-error
                              >
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>MI</mat-label>
                              <input
                                matInput
                                type="text"
                                name="othermiNm"
                                [(ngModel)]="othermiNm"
                                maxlength="1"
                                #otherMi="ngModel"
                                uppercase
                                (keypress)="
                                  allowOnlyOneAlphabet($event, otherMi)
                                "
                              />
                              <mat-error *ngIf="otherMi.errors?.['invalid']"
                                >Middle Name is invalid</mat-error
                              >
                              <mat-error *ngIf="otherMi.errors?.['nomatch']"
                                >Only Alphabet is allowed</mat-error
                              >
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >Last Name<ng-container *ngIf="!otherLnRequired"
                                  >*</ng-container
                                ></mat-label
                              >
                              <input
                                matInput
                                type="text"
                                name="otherlastNm"
                                [(ngModel)]="otherlastNm"
                                maxlength="20"
                                #otherLN="ngModel"
                                [required]="otherLnRequired"
                                pattern="^[a-zA-Z](?!.*--)(?!.*-')(?!.* ')(?!.*'-)(?!.*' )(?!.* -)(?!.*- )(?!.*  )(?!.*'')[a-zA-Z \-']+$"
                                uppercase
                                (keypress)="allowAlphabets2($event, otherLN)"
                                (blur)="nomatchCheck($event, otherLN)"
                              />
                              <mat-error *ngIf="otherLN.errors?.['required'] && !otherFN.errors?.['nomatch']"
                                >Last Name is required</mat-error
                              >
                              <mat-error *ngIf="otherLN.errors?.['invalid']"
                                >Last Name is invalid</mat-error
                              >
                              <mat-error *ngIf="otherLN.errors?.['pattern']"
                                >Last Name is invalid</mat-error
                              >
                              <mat-error *ngIf="otherLN.errors?.['nomatch']"
                                >Only Alphabetical, Space, Hyphen and ' are allowed</mat-error
                              >
                            </mat-form-field>
                          </div>
                        </div>
                        <br />

<!-- CMO Enrollment Question - shown after First and Last Name are entered -->
                        <div *ngIf="(otherfirstNm?.trim() && otherlastNm?.trim()) || isEditingMember" class="mt-2 mb-3">
                          <div class="row">
                            <div class="col">
                              <mat-label>
                                Is this family member enrolled in one of the following Care Management Organization (CMO): Caresource, Amerigroup or Peachstate Health Plan?
                                <span class="text-danger">*</span>
                              </mat-label>
                              <br />
                              <mat-radio-group
                                color="primary"
                                aria-label="CMO enrollment"
                                [(ngModel)]="isFamilyCmoEnrolled"
                                name="isFamilyCmoEnrolled"
                                #familyCmoEnrolled="ngModel"
                                (change)="cmoProceed = ''; familyCmoProceedRequired = false"
                                [required]="isFamilyCmoEnrolledRequired"
                              >
                                <mat-radio-button value="Yes">Yes</mat-radio-button>
                                <mat-radio-button value="No">No</mat-radio-button>
                              </mat-radio-group>
                              <mat-error *ngIf="familyCmoEnrolled.errors?.['required'] && isFamilyCmoEnrolledRequired">Your response is required</mat-error>
                            </div>
                          </div>

                          <!-- CMO Warning & Proceed Question (shown when CMO answer is Yes) -->
                          <div *ngIf="isFamilyCmoEnrolled == 'Yes'" class="row mt-3">
                            <div class="col">
                              <mat-label>
                                If you are eligible and approved for HIPP while enrolled in a CMO, you will be disenrolled from the CMO and enrolled in the Fee-For-Service (FFS) traditional Medicaid program. Under FFS Medicaid, the State of Georgia pays providers directly on a per-service basis. We encourage you to compare the benefits and services offered to determine what best suits your family's needs. <a style="color: #064EBA;" lang="en" href="javascript:void(0)" 
        aria-label="Download CMO FAQ" (click)="openCMOFAQ()">CMO FAQ</a> Would you like to proceed with your application?
                                <span class="text-danger">*</span>
                              </mat-label>
                              <br />
                              <mat-radio-group
                                color="primary"
                                aria-label="CMO proceed"
                                [(ngModel)]="cmoProceed"
                                name="cmoProceed"
                                #cmoProceedResp="ngModel"
                                [required]="familyCmoProceedRequired"
                              >
                                <mat-radio-button value="Yes">Yes</mat-radio-button>
                                <mat-radio-button value="No">No</mat-radio-button>
                              </mat-radio-group>
                              <mat-error *ngIf="cmoProceedResp.errors?.['required'] && familyCmoProceedRequired">Your response is required</mat-error>
                              <div *ngIf="cmoProceed == 'No'" class="mt-2">
                                <br />
                                <mat-error style="display: inline-flex; align-items: center; flex-wrap: wrap; gap: 4px;">
                                  You must select "Yes" to proceed with this member or to add more family member click
                                  <button
                                    mat-raised-button
                                    type="button"
                                    class="m-1"
                                    (click)="clear($event)"
                                  >
                                    Reset Family Member
                                  </button>
                                </mat-error>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Remaining fields - shown after CMO is answered appropriately -->
                        <ng-container *ngIf="isFamilyCmoEnrolled == 'No' || (isFamilyCmoEnrolled == 'Yes' && cmoProceed == 'Yes')">
                        <br />
                        <div class="row">
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >Social Security Number<ng-container
                                  *ngIf="!otherSsnRequired"
                                  >*</ng-container
                                ></mat-label
                              >
                              <input
                                matInput
                                type="text"
                                name="otherssnNum"
                                [(ngModel)]="otherssnNum"
                                (input)="
                                  otherssnNum = ssnmask($event, otherSsn)
                                "
                                maxlength="11"
                                (keypress)="isNumeric($event, otherSsn)"
                                #otherSsn="ngModel"
                                (blur)="verifySSN($event, true, otherSsn)"
                                pattern="^\d{3}-\d{2}-\d{4}$"
                                [required]="otherSsnRequired"
                              />
                              <mat-error *ngIf="otherSsn.errors?.['required'] && !otherSsn.errors?.['nomatch']"
                                >Social Security Number is required</mat-error
                              >
                              <mat-error *ngIf="otherSsn.errors?.['invalid']"
                                >Social Security Number is invalid</mat-error
                              >
                              <mat-error *ngIf="otherSsn.errors?.['invalidSsn']"
                                >Social Security Number is invalid</mat-error
                              >
                              <mat-error *ngIf="otherSsn.errors?.['pattern']">
                                <ng-container *ngIf="otherssnNum.length < 11"
                                  >Social Security Number length is
                                  short</ng-container
                                >
                                <ng-container *ngIf="otherssnNum.length > 10"
                                  >Social Security Number is
                                  invalid</ng-container
                                >
                              </mat-error>
                              <mat-error *ngIf="otherSsn.errors?.['duplicate']"
                                >SSN already used.</mat-error
                              >
                              <mat-error
                                *ngIf="otherSsn.errors?.['recordPresent']"
                                >{{ getSSNUsedMessage() }}</mat-error
                              >
                              <mat-error *ngIf="otherSsn.errors?.['nomatch']"
                                >Only numerical values are allowed</mat-error
                              >
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >Date of Birth<ng-container
                                  *ngIf="!otherDobRequired"
                                  >*</ng-container
                                ></mat-label
                              >
                              <input
                                matInput
                                [matDatepicker]="picker4"
                                [min]="prev100year"
                                [max]="today"
                                name="d6"
                                [(ngModel)]="otherdobDate"
                                [required]="otherDobRequired"
                                #otherDob="ngModel"
                                minlength="8"
                                maxlength="10"
                                placeholder="MMDDYYYY"
                                (input)="datemask2($event, otherDob)"
                                (blur)="parseDate($event, otherDob)"
                                (keypress)="onlyNumeric($event, otherDob)"
                              />

                              <mat-datepicker-toggle
                                matIconSuffix
                                [for]="picker4"
                              ></mat-datepicker-toggle>
                              <mat-datepicker #picker4></mat-datepicker>
                              <mat-error *ngIf="otherDob.errors?.['required'] && !otherDob.errors?.['nomatch']"
                                >Date of Birth is required</mat-error
                              >
                              <mat-error *ngIf="otherDob.errors?.['invalid']"
                                >Date of Birth is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="otherDob.errors?.['matDatepickerMin']"
                                >Date of Birth is out of range</mat-error
                              >
                              <mat-error
                                *ngIf="otherDob.errors?.['matDatepickerMax']"
                                >Date of Birth is out of range</mat-error
                              >
                              <mat-error *ngIf="otherDob.errors?.['nomatch']"
                                >Only numerical values are allowed</mat-error
                              >
                              <mat-error
                                *ngIf="otherDob.errors?.['invalidDate']"
                                >Date of Birth is invalid</mat-error
                              >
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >Gender
                                <ng-container *ngIf="!otherGnRequired"
                                  >*</ng-container
                                >
                              </mat-label>
                              <select
                                matNativeControl
                                name="othergencdRf"
                                [(ngModel)]="othergencdRf"
                                #otherGender="ngModel"
                                (change)="isPregnantOtherFn()"
                                aria-label="Default select example"
                                [required]="otherGnRequired"
                              >
                                <ng-container
                                  *ngIf="preference.dropDownValues != null"
                                >
                                  <option
                                    *ngFor="
                                      let g of preference.dropDownValues[
                                        'GENCD'
                                      ] | keyvalue : originalOrder
                                    "
                                    [value]="g.key"
                                  >
                                    {{ g.value }}
                                  </option>
                                </ng-container>
                              </select>
                              <mat-error
                                *ngIf="otherGender.errors?.['required']"
                                >Gender is required</mat-error
                              >
                            </mat-form-field>
                          </div>
                        </div>
                        <br />
                        <div class="row">
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >Medicaid ID Number<ng-container
                                  *ngIf="!othermaNumRequired"
                                  >*</ng-container
                                ></mat-label
                              >
                              <input
                                matInput
                                type="text"
                                name="othermaNum"
                                [(ngModel)]="othermaNum"
                                uppercase
                                maxlength="12"
                                pattern="^\d{12}$"
                                #otherVOmaNum="ngModel"
                                (keypress)="isNumeric($event, otherVOmaNum)"
                                (blur)="isMedicaidValid($event, otherVOmaNum)"
                                [required]="othermaNumRequired"
                              />
                              <mat-error
                                *ngIf="otherVOmaNum.errors?.['required'] && !otherVOmaNum.errors?.['nomatch']"
                                >Medicaid ID number is required</mat-error
                              >
                              <mat-error
                                *ngIf="otherVOmaNum.errors?.['pattern']"
                                >Medicaid ID number is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="otherVOmaNum.errors?.['invalid']"
                                >Medicaid ID number is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="otherVOmaNum.errors?.['invalid2']"
                                >Medicaid ID number should start with 111 or 222.</mat-error
                              >
                              <mat-error
                                *ngIf="otherVOmaNum.errors?.['nomatch']"
                                >Only numerical values are allowed</mat-error
                              >
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >Relationship to Policyholder<ng-container
                                  *ngIf="!otherRsRequired"
                                  >*</ng-container
                                ></mat-label
                              >
                              <select
                                matNativeControl
                                name="otherrshcdRf"
                                aria-label="Default select example"
                                [(ngModel)]="otherrshcdRf"
                                #otherRelationship="ngModel"
                                [required]="otherRsRequired"
                              >
                                <ng-container
                                  *ngIf="preference.dropDownValues != null"
                                >
                                  <option
                                    *ngFor="
                                      let r of preference.dropDownValues[
                                        'RSHCD'
                                      ] | keyvalue : originalOrder
                                    "
                                    [value]="r.key"
                                  >
                                    {{ r.value }}
                                  </option>
                                </ng-container>
                              </select>
                              <mat-error
                                *ngIf="otherRelationship.errors?.['required']"
                                >Relationship is required</mat-error
                              >
                            </mat-form-field>
                          </div>
                        </div>
                        <br />
                        <div class="row">
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>Medical Conditions</mat-label>
                              <input
                                matInput
                                type="text"
                                name="otherSpecialCond"
                                [(ngModel)]="otherSpecialCond"
                                maxlength="100"
                                #otherSpecialCondition="ngModel"
                                uppercase
                              />
                              <mat-error
                                *ngIf="otherSpecialCondition.errors?.['invalid']"
                                >Medical conditions is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="otherSpecialCondition.errors?.['nomatch']"
                                >Only Alphabet is allowed</mat-error
                              >
                            </mat-form-field>
                          </div>
                        </div>
                        <br *ngIf="othergencdRf == 'F'"/>
                        
                        <div *ngIf="othergencdRf == 'F'" class="row">
                          <div class="col">
                            <mat-label>Is this person pregnant?
                             <span class="text-danger">*</span></mat-label>
        
                            <mat-radio-group #group aria-label="Select an option" [(ngModel)]="pregnantOther"
                              [required]="pregnantOtherRequired" name="pregnantOther" #pregnantOtherResponse="ngModel"
                              (click)="isPregnantOther()">
                              <mat-radio-button value="Yes">
                                Yes
                              </mat-radio-button>
                              <mat-radio-button value="No">
                                No
                              </mat-radio-button>
                              <mat-error *ngIf="pregnantOtherResponse.errors?.['required']">Your Response is
                                Required</mat-error>
                            </mat-radio-group>
                          </div>
                          <div class="col">
                            <div *ngIf="pregnantOther == 'Yes'">
                              <mat-form-field appearance="outline">
                                <mat-label>Due Date<ng-container *ngIf="!otherDueDateRequired">*</ng-container></mat-label>
                                <input matInput [matDatepicker]="picker7" name="d7" #c7="ngModel"
                                  [(ngModel)]="otherMemberDueDate" [min]="today" [max]="plus1year" required minlength="8"
                                  maxlength="10" placeholder="MMDDYYYY" (input)="datemask2($event, c7)"
                                  (blur)="parseDate($event, c7)"
                                  [required]="otherDueDateRequired" (keypress)="onlyNumeric($event, c7)" />
        
                                <mat-datepicker-toggle matIconSuffix [for]="picker7"></mat-datepicker-toggle>
                                <mat-datepicker #picker7></mat-datepicker>
                                <mat-error *ngIf="c7.errors?.['required'] && !c7.errors?.['nomatch']">Due date is required</mat-error>
                                <mat-error *ngIf="c7.errors?.['invalid']">Due date is invalid</mat-error>
                                <mat-error *ngIf="c7.errors?.['matDatepickerMin']">Due date is out of range</mat-error>
                                <mat-error *ngIf="c7.errors?.['matDatepickerMax']">Due date is out of range</mat-error>
                                <mat-error *ngIf="c7.errors?.['nomatch']">Only numerical values are allowed</mat-error>
                                <mat-error *ngIf="c7.errors?.['invalidDate']">Due Date is invalid</mat-error>
                              </mat-form-field>
                            </div>
                          </div>
                         
                        </div>
                        <br />
                        <div class="row">
                          <div class="col">
                            <mat-label
                              >Is this person enrolled in the health insurance
                              plan listed in previous page?
                              <span class="text-danger">*</span>
                            </mat-label>

                            <mat-radio-group
                              color="primary"
                              #group
                              aria-label="Select an option"
                              [(ngModel)]="otherEnrolled"
                              name="otherEnrolled"
                              #otherEnrolledResp="ngModel"
                              [required]="otherEnrolledRequired"
                            >
                              <mat-radio-button value="Yes">
                                Yes
                              </mat-radio-button>
                              <mat-radio-button value="No">
                                No
                              </mat-radio-button>
                              <mat-error
                                *ngIf="otherEnrolledResp.errors?.['required']"
                                >Your Response is Required</mat-error
                              >
                            </mat-radio-group>
                          </div>
                          <mat-error *ngIf="addClearFamilyFilled"
                            >Do you want to add or clear the filled family
                            member details before clicking on the Next
                            button?</mat-error
                          >
                        </div>
                        <div class="row">
                          <div class="col text-center">
                            <button
                              id="addFamilyMember"
                              mat-raised-button
                              color="primary"
                              type="button"
                              class="m-1"
                              [disabled]="addFamilyMemberButton"
                              (click)="addFamilyMember($event)"
                            >
                              <ng-container *ngIf="editIndex == undefined"
                                >Add Family Member</ng-container
                              >
                              <ng-container *ngIf="editIndex != undefined"
                                >Save Family Member</ng-container
                              >
                            </button>
                            <button
                              id="clearFamilyMember"
                              mat-raised-button
                              type="button"
                              class="m-1"
                              (click)="clear($event)"
                            >
                              Clear Family Member
                            </button>
                          </div>
                        </div>
                        </ng-container>
                        <br />
                      </mat-card-content>
                    </mat-card>
                  </div>

                  <div *ngIf="formGa.referralMemberList.length > 0">
                    <br />
                    <div class="text-center fw-bold">
                      Below are the family members you have already added
                    </div>
                      <br />

                      <table
                        mat-table
                        class="table table-bordered table-hover mat-elevation-z8"
                        style="border: 2px solid #63b1bc"
                      >
                        <thead class="table-success">
                          <tr>
                            <th scope="col">First Name</th>
                            <th scope="col">Middle Initial</th>
                            <th scope="col">Last Name</th>
                            <th scope="col">Medicaid ID</th>
                            <th scope="col">Social Security Number</th>
                            <th scope="col">Date of Birth</th>
                            <th scope="col">Gender</th>
                            <th scope="col">Relationship</th>
                            <th scope="col"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            *ngFor="
                              let p of formGa.referralMemberList;
                              let i = index
                            "
                          >
                            <td>{{ p.firstNm }}</td>
                            <td>{{ p.miNm }}</td>
                            <td>{{ p.lastNm }}</td>
                            <td>{{ p.maNum }}</td>
                            <td>{{ p.ssnNum }}</td>
                            <td>{{ p.dobDt }}</td>
                            <td>
                              <ng-container *ngIf="p.genderCd == 'F'"
                                >Female</ng-container
                              >
                              <ng-container *ngIf="p.genderCd == 'M'"
                                >Male</ng-container
                              >
                            </td>
                            <td>{{ p.relationshipCd }}</td>
                            <td>
                              <button
                                mat-mini-fab
                                color="warn"
                                id="removeMember"
                                (click)="removeMember(i)"
                              >
                                <span class="bi bi-trash"></span>
                              </button>
                              <button
                                mat-mini-fab
                                color="primary"
                                id="editMember"
                                (click)="editMember(i)"
                              >
                                <span class="bi bi-pencil-square"></span>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                  </div>
                  <div class="row" *ngIf="isFamilyMemberMedicate == 'Yes' && (isFamilyCmoEnrolled == '' || isFamilyCmoEnrolled == 'No' || (isFamilyCmoEnrolled == 'Yes' && (cmoProceed == 'Yes' || cmoProceed == '')))">                  
                    <mat-error *ngIf="additionalMembersReq">
                      At least one family member should be added.
                    </mat-error>
                    <mat-error *ngIf="additionalMaxReached">
                      Family member limit has reached to 50.
                    </mat-error>
                  </div>
                  <ng-container
                    *ngIf="
                      isFamilyMemberMedicate == 'No' && isMemberMedicaid == 'No'
                    "
                  >
                    <mat-card>
                      <mat-card-content>
                        <div class="alert alert-danger d-flex" role="alert">
                          <i class="bi bi-exclamation-triangle-fill px-2"></i>

                          Georgia HIPP applicants must be active Medicaid clients. Based on your responses, you do not qualify for HIPP. If you have any questions, you can contact the HIPP Unit at {{tollfreeNo}} Option 1.
                        </div>
                      </mat-card-content>
                    </mat-card>
                  </ng-container>

                  <br />

                  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button
                      mat-raised-button
                      color="warn"
                      matStepperPrevious
                      style="background-color: #b89d18; color: white"
                      (click)="goBack2()"
                    >
                      Previous
                    </button>
                    <ng-container
                      *ngIf="
                        !(
                          isFamilyMemberMedicate == 'No' &&
                          isMemberMedicaid == 'No'
                        )
                      "
                    >
                      <button
                        mat-raised-button
                        color="primary"
                        (click)="goForward2()"
                      >
                        Next
                      </button></ng-container
                    >
                  </div>
                </fieldset>
              </mat-step>
              <mat-step
                label="EOB's"
                [completed]="eobChecked()"
              >
                <fieldset
                  class="shadow p-5 mb-1 rounded-5"
                  style="border: 2px solid #63b1bc"
                >
                  <legend
                    class="float-none w-auto p-1 mx-5 fw-bold fs-1"
                    style="color: #0f6db7"
                  >
                  Explanation of Benefits (EOBs)
                  </legend>
                  <div>
                    <p class="fw-bold">Helpful information for submitting Explanation of Benefits (EOBs)</p>
                    
                  </div>
                  <ul class="liststyle">
                    <li>You may need to contact the health insurance company you had benefits with in <b>{{eobYear}}</b>.</li>
                    <li>Request a listing or report that will provide claim detail information for medical and prescription services the Medicaid Member(s) received during <b>{{eobYear}}</b>.</li>
                    <li>Your request should be based on the date of service and not the date the claim was paid.</li>
                    <li>The listing or report must provide the name of the patient, the dates of services, the amount billed by the provider, and the amount paid by the insurance carrier. HIPP will only accept listings or reports from the insurance carrier. This document should not be altered in any way. If any alterations are detected by the HIPP Unit, the listing or report will not be used to determine program eligibility. If you provide false information you may be automatically terminated from the HIPP Program and subject to legal action by the Department of Community Health.</li>
                    <li>For prescription EOBS, it may be necessary to contact the insurance company that processes your prescription claims. We will not be able to accept receipts, listings, or reports from the pharmacy.</li>
                    <li>If you are not able to obtain a listing or report, you may send copies of the EOBs. Please do not send originals as we will not be able to copy and return them to you.</li>
                    <li>Please note any documentation received in envelopes not addressed directly to the HIPP Unit will be returned to you. Unfortunately, we cannot open mail addressed to you. You will need to remove documents from the envelopes mailed to you from your insurance company. Please review the documents and only submit EOBS for the Medicaid Member(s) only. Please do not submit any pages that do not provide claim detail information.</li>
                    <li>Please adhere to the fifty (50) page fax/email limit for your entire packet. If your entire review packet (EOBS included) exceeds fifty (50) pages, please mail the review packet.</li>
                    <li>If you need to request the medical and prescription EOBS from the insurance companies, please do not return the review packet until you are able to attach the EOBS. For faster processing, all documents should be submitted together.</li>
                    

                  </ul>
                  <input type="hidden" name="eobnextButtonClicked" [(ngModel)]="eobnextButtonClicked" />
                  <br />
                  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button
                      mat-raised-button
                      color="warn"
                      matStepperPrevious
                     
                      style="background-color: #b89d18; color: white"
                    >
                      Previous
                    </button>
                    <button
                      mat-raised-button
                      color="primary"
                      matStepperNext
                    >
                      Next
                    </button>
                  </div>
                </fieldset>
              </mat-step>
              <mat-step *ngIf="existingMember == 'Yes'"
                label="Required Documents"
                [completed]="requiredDocumentsChecked()"
              >
                <fieldset
                  class="shadow p-5 mb-1 rounded-5"
                  style="border: 2px solid #63b1bc"
                >
                  <legend
                    class="float-none w-auto p-1 mx-5 fw-bold fs-1"
                    style="color: #0f6db7"
                  >
                  Required Documents
                  </legend>
                  <div>
                    <mat-card class="mat-elevation-z4">
                      
                      <mat-card-content>
                        <p >To complete your updates for the Georgia HIPP Program, you must download and complete the following documents.</p>
                    <p></p>
                    <div class="ps-5"> <strong><a style="color: #064EBA;" lang="en" href="javascript:void(0)" (click)="pdfData(empInsuranceDataPdf, 'EmpInsuranceForm.pdf')">Employer Health Insurance Data Form</a></strong></div>
                    <div class="ps-5"> <strong><a style="color: #064EBA;" lang="en" href="javascript:void(0)" (click)="pdfData(documentChecklistPdf, 'DocumentCheckListForm.pdf')">Document Checklist</a></strong></div>
                    <p></p>
                    <p>Please return the completed forms to:<br/>
                      Gainwell Technologies/HIPP Unit<br/>
                      {{mailingAddressLine2}}<br />
                      {{mailingAddressLine3}}<br />
                      {{mailingCityStateZip}}<br />
                      Fax: {{faxNo}}<br />
                      Email: <span style="color: #064EBA;">{{email}}</span> (for attachments PDF format is preferred)<br />
                    </p>
                      </mat-card-content>
                    </mat-card>
                    
                    <br />
                    <mat-card class="mat-elevation-z4">
                      <mat-card-header>
                        <mat-card-subtitle
                          ><label
                            ><strong>Acknowledgement of Participation</strong>
                          </label></mat-card-subtitle
                        >
                      </mat-card-header>
                      <mat-card-content>
                        <br/>
                        <p>
                          Please find outlined below the program changes for the Health Insurance Premium Payment (HIPP) Program. All changes are effective on <b>January 1, {{benefitYear}}</b>.</p>
                          Please review the following: 
                           
                          <section class="example-section-custom">
                            <mat-slide-toggle
                              color="primary"
                              class="example-margin"
                              name="readDocLine1"
                              [(ngModel)]="readDocLine1"
                              #readDocLine1Checked="ngModel"
                              [required]="readDocLine1Required"
                              ><span class="text-danger">*</span></mat-slide-toggle
                            >All participating members are required to be on Medicaid during their participation in the HIPP Program. If a member is no longer eligible for Medicaid, they are not eligible to participate in the HIPP Program. Peachcare for Kids participants are not eligible for participation in the HIPP Program.
                          </section>
                          <mat-error class="mat-error-custom"
                            *ngIf="readDocLine1Checked.errors?.['required'] && customerForm.submitted"
                            >Your response is required</mat-error
                          >
                          <section class="example-section-custom">
                            <mat-slide-toggle
                              color="primary"
                              class="example-margin"
                              name="readDocLine2"
                              [(ngModel)]="readDocLine2"
                              #readDocLine2Checked="ngModel"
                              [required]="readDocLine2Required"
                              ><span class="text-danger">*</span></mat-slide-toggle
                            >
                          All HIPP member(s) have until the 15th calendar day of the following month to submit all required documentation for reimbursement. Premium payment documentation includes, but are not limited to paystub, bank statements, cancelled checks, money order receipts, and cashier checks. If premiums are not paid by payroll deduction, you will be required to submit supporting document(s) with your premium payment documentation. Supporting documentation may include premium notices, invoices, or statements. Please submit copies of all pay stubs with a pay period ending date for the month of reimbursement.
                          </section>
                      
                          <mat-error class="mat-error-custom"
                            *ngIf="readDocLine2Checked.errors?.['required'] && customerForm.submitted"
                            >Your response is required</mat-error
                          >
                          <section class="example-section-custom">
                            <mat-slide-toggle
                              color="primary"
                              class="example-margin"
                              name="readDocLine3"
                              [(ngModel)]="readDocLine3"
                              #readDocLine3Checked="ngModel"
                              [required]="readDocLine3Required"
                              ><span class="text-danger">*</span></mat-slide-toggle
                            >If a member fails to submit the required documentation by the deadline stated above, reimbursement for the month will be forfeited. Please make sure you keep proof of submission for your records. This will be your confirmation of submission receipt. We recommend the following: either mailing it U.S. Certified Mail Return Receipt, have your fax machine print a confirmation statement or saving your sent email and/or email auto response from Gainwell Technologies. You may also follow-up with the Gainwell Technologies/HIPP Unit to confirm receipt of premium payment documentation. It is recommended that you contact the Gainwell Technologies/HIPP Unit the next business day following your submission. Preferred method of communication is by phone.
                          </section>
                         
                          <mat-error class="mat-error-custom"
                            *ngIf="readDocLine3Checked.errors?.['required'] && customerForm.submitted"
                            >Your response is required</mat-error
                          >
                          <section class="example-section-custom">
                            <mat-slide-toggle
                              color="primary"
                              class="example-margin"
                              name="readDocLine4"
                              [(ngModel)]="readDocLine4"
                              #readDocLine4Checked="ngModel"
                              [required]="readDocLine4Required"
                              ><span class="text-danger">*</span></mat-slide-toggle
                            >ALL HIPP member(s) have 30 calendar days following the reimbursement month to contact HIPP if they have not received their reimbursement for that month.
                          </section>
                         
                          <mat-error class="mat-error-custom"
                            *ngIf="readDocLine4Checked.errors?.['required'] && customerForm.submitted"
                            >Your response is required</mat-error
                          >
                          <section class="example-section-custom">
                            <mat-slide-toggle
                              color="primary"
                              class="example-margin"
                              name="readDocLine5"
                              [(ngModel)]="readDocLine5"
                              #readDocLine5Checked="ngModel"
                              [required]="readDocLine5Required"
                              ><span class="text-danger">*</span></mat-slide-toggle
                            >The HIPP Program will review extenuating circumstances and may allow a one-time pass for processing reimbursement. A one-time pass will only be allowed once per case per calendar year. A letter requesting the one-time pass must be received by the Gainwell Technologies/HIPP Unit within the 30 calendar days following the reimbursement month for consideration. Requests received after the applicable deadline may result in denial of the one-time pass request.
                          </section>
                         
                          <mat-error class="mat-error-custom"
                            *ngIf="readDocLine5Checked.errors?.['required'] && customerForm.submitted"
                            >Your response is required</mat-error
                          >
                          <section class="example-section-custom">
                            <mat-slide-toggle
                              color="primary"
                              class="example-margin"
                              name="readDocLine6"
                              [(ngModel)]="readDocLine6"
                              #readDocLine6Checked="ngModel"
                              [required]="readDocLine6Required"
                              ><span class="text-danger">*</span></mat-slide-toggle
                            >You are encouraged to deposit or cash your reimbursement checks as soon as possible. No checks will be re-issued to a member after the stale date of 180 calendar days.
                          </section>
                          <mat-error class="mat-error-custom"
                            *ngIf="readDocLine6Checked.errors?.['required'] && customerForm.submitted"
                            >Your response is required</mat-error
                          >
                          <section class="example-section-custom">
                            <mat-slide-toggle
                              color="primary"
                              class="example-margin"
                              name="readDocLine7"
                              [(ngModel)]="readDocLine7"
                              #readDocLine7Checked="ngModel"
                              [required]="readDocLine7Required"
                              ><span class="text-danger">*</span></mat-slide-toggle
                            >Reimbursements for all new applicants for the HIPP Program will begin with the month for which the application is received by the Gainwell Technologies/HIPP Unit.
                          </section>
                          <mat-error class="mat-error-custom"
                            *ngIf="readDocLine7Checked.errors?.['required'] && customerForm.submitted"
                            >Your response is required</mat-error
                          >
                          <section class="example-section-custom">
                            <mat-slide-toggle
                              color="primary"
                              class="example-margin"
                              name="readDocLine8"
                              [(ngModel)]="readDocLine8"
                              #readDocLine8Checked="ngModel" 
                              [required]="readDocLine8Required"
                              ><span class="text-danger">*</span></mat-slide-toggle
                            >All participating members are requested to respond to written requests made by the Gainwell Technologies/HIPP Unit on or before 5:00 PM of the due date.
                          </section>
                          <mat-error class="mat-error-custom"
                            *ngIf="readDocLine8Checked.errors?.['required'] && customerForm.submitted"
                            >Your response is required</mat-error
                          >
                          <section class="example-section-custom">
                            <mat-slide-toggle
                              color="primary"
                              class="example-margin"
                              name="readDocLine9"
                              [(ngModel)]="readDocLine9"
                              #readDocLine9Checked="ngModel"
                              [required]="readDocLine9Required"
                              ><span class="text-danger">*</span></mat-slide-toggle
                            >If the HIPP case is terminated or denied, you will be required to re-apply. Please contact the Gainwell Technologies/HIPP Unit for an application packet. All applications are approved for the month the application is received by the Gainwell Technologies/HIPP Unit.
                          </section>
                          <mat-error class="mat-error-custom"
                            *ngIf="readDocLine9Checked.errors?.['required'] && customerForm.submitted"
                            >Your response is required</mat-error
                          >
                          <section class="example-section-custom">
                            
                            <mat-slide-toggle
                              color="primary"
                              class="example-margin"
                              name="readDocLine10"
                              [(ngModel)]="readDocLine10"
                              #readDocLine10Checked="ngModel"
                              [required]="readDocLine10Required"
                              ><span class="text-danger">*</span></mat-slide-toggle
                            >All employer, policyholder, or insurance coverage changes must be reported to the Gainwell Technologies/HIPP Unit within thirty (30) calendar days of the change. Employer changes include but are not limited to company acquisitions. If the employer or policyholder has changed, you will be required to re-apply. Please contact the Gainwell Technologies/HIPP Unit for an application packet. All applications are approved for the month the application is received by the Gainwell Technologies/HIPP Unit.
                          </section>
                          
                          <mat-error class="mat-error-custom"
                            *ngIf="readDocLine10Checked.errors?.['required'] && customerForm.submitted"
                            >Your response is required</mat-error
                          >
                        
                      </mat-card-content>
                    </mat-card>


                  </div>
                  <br />
                  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button
                      mat-raised-button
                      color="warn"
                      matStepperPrevious
                      (click)="previousRequiredDoc()"
                      style="background-color: #b89d18; color: white"
                    >
                      Previous
                    </button>
                    <button
                      mat-raised-button
                      color="primary"
                      matStepperNext
                      (click)="nextRequiredDoc()"
                    >
                      Next
                    </button>
                  </div>
                </fieldset>
              </mat-step>
              <mat-step
                label="Emailing HIPP"
                [completed]="emailHippChecked()"
              >
                <fieldset
                  class="shadow p-5 mb-1 rounded-5"
                  style="border: 2px solid #63b1bc"
                >
                  <legend
                    class="float-none w-auto p-1 mx-5 fw-bold fs-1"
                    style="color: #0f6db7"
                  >
                  Emailing HIPP
                  </legend>
                  <div>
                    <p >The HIPP Program is pleased to provide an email address for submission of premium payment documentation and correspondence. You may also continue to utilize fax or mail.</p>
                    <p ><strong><a  target="_blank" [href]="emailTo" alt="Email" title="email" lang="en" style="color: #064EBA;">{{email | uppercase}}</a> </strong> </p>
                    <p>The HIPP Unit will have online confirmation of your emailed information, the ability to provide instant encryption of your data for privacy protection, and instant imaging for document retention.</p>
                    <p>In order for your documentation to be viewed and/or processed more timely, please consider the following when sending your documentation and correspondence:</p>
                    
                    <ol class="liststyle3">
                      <li>Similar to the mail and fax process, this email address is for the purpose of submitting HIPP related documentation attachments only. Please do not type messages in the body of the email. Any additional messages can be typed on a separate document that can also be submitted as an attachment.</li>
                      <li>The preferred method for attachments is PDF format. PDF is a format that cannot be modified or altered during the email and receipt process.</li>
                      <li>Please make sure your documents are clear and legible.</li>
                      <li>Your data is encrypted for privacy protection. It is not necessary to send secured email messages. Please do not send zip files.</li>
                      <li>Gainwell Technologies will send an auto response message for all received email messages. You should expect an auto response for each sent email. If you do not receive an auto response please confirm you have the correct email address and your attachments are the preferred document type (PDF).</li>
                      <li>While it is not required, it is recommended you contact the HIPP Unit the next business day to confirm receipt of your document attachments.</li>
                    </ol>
                    <div >For faster processing of your documentation, please choose from the following subjects to appear on the subject line of your email as: <span style="color: orange; font-weight: bold;"> LastName_DocumentType (Ex: Jones_InsuranceCard) </span>
                    </div>
                      <ul  style="list-style-type: none">
                        <li>&#x27A2; Premium payment documentation (paystub, etc.)</li>
                        <li>&#x27A2; New application</li>
                        <li>&#x27A2; Case review documents</li>
                        <li>&#x27A2; Member outreach (address change forms, policy change letters)</li>
                      </ul>
                     
                      
                    <p class="fw-bold">IF YOU HAVE ANY QUESTIONS, COMMENTS, OR CONCERNS, PLEASE CALL THE HIPP UNIT AT {{tollfreeNo}}, OPTION 1.</p>
                  </div>
                  <br />
                  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button
                      mat-raised-button
                      color="warn"
                      matStepperPrevious
                     
                      style="background-color: #b89d18; color: white"
                    >
                      Previous
                    </button>
                    <button
                      mat-raised-button
                      color="primary"
                      matStepperNext
                    (click)="emailHippButtonClicked = true"
                    >
                      Next
                    </button>
                  </div>
                </fieldset>
              </mat-step>
              <mat-step  *ngIf="existingMember == 'Yes'"
                label="Direct Deposit"
                [completed]="directDepositFn()"
              >
                <fieldset
                  class="shadow p-5 mb-1 rounded-5"
                  style="border: 2px solid #63b1bc"
                >
                  <legend
                    class="float-none w-auto p-1 mx-5 fw-bold fs-1"
                    style="color: #0f6db7"
                  >
                  Direct Deposit
                  </legend>
                  <div>
                    <p class="fw-bold fs-3">DIRECT DEPOSIT</p>
                    <p>The Health Insurance Premium Payment (HIPP) program has an even faster way for you to be reimbursed each month through direct deposit.</p>
                    <p>With direct deposit, the Gainwell Technologies/HIPP Unit will put your premium payment into the policyholder's checking or savings account.</p>
                    <p>
                      <strong># It's easy!</strong> Your payment goes straight into your bank account.<br />
                      <strong># It's fast!</strong> You can get your payment the same day we deposit it.<br />
                      <strong># It's safe!</strong> Your money will not get lost, stolen, or delayed.<br />
                    </p>
                   
                      You can set up direct deposit in 3 easy steps:
                      <ol>
                        <li>Fill out the form below.</li>
                        <li>Write "VOID" across the front of one of the policyholder's blank checks.</li>
                        <li>Complete and fax, email, or mail the voided check.</li>
                      </ol>
                      
                    
                    <p>Please send the voided check for checking account or deposit slip for savings account to the Gainwell Technologies/HIPP Unit. 1. {{mailingAddressLine2}}<ng-container *ngIf="mailingAddressLine3"> {{mailingAddressLine3}}</ng-container>, {{mailingCityStateZip}}, or Email: {{email}}, or Fax: {{faxNo}}. Please call Gainwell Technologies/HIPP Unit at {{tollfreeNo}}, Option 1 if you have questions.</p>
                    <section class="example-section">
                      <mat-slide-toggle
                        color="primary"
                        class="example-margin"
                        name="directDepositCheck"
                        [(ngModel)]="directDepositCheck"
                        (change)="directDeposit()"
                        #directDepositChecked="ngModel"
                        [required]="directDepositRequired"
                        >If accepted onto the GAHIPP program, I would like to participate in Direct Deposit. By doing so, GAHIPP will deposit my payments into my checking or saving account and I will not receive a paper check. If I am not accepted into the program, GAHIPP will properly discard my banking information.</mat-slide-toggle
                      >
                    </section>
                    <mat-error
                      *ngIf="directDepositChecked.errors?.['required'] && customerForm.submitted"
                      >Your response is required</mat-error
                    >

                    <ng-container *ngIf="directDepositCheck">
                      <br />
                      <div class="row">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Account Holder</mat-label>
                            <input
                              matInput
                              type="text"
                              name="deposit.accountHolderName"
                              [(ngModel)]="depositAccountHolderName"
                              readonly
                            />
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Bank Name<ng-container
                              *ngIf="!depositBankNmRequired"
                              >*</ng-container></mat-label>
                            <input
                              matInput
                              type="text"
                              name="deposit.bankName"
                              [(ngModel)]="depositBankName"
                              pattern="^[A-Za-z .]{0,100}$"
                              maxlength="100"
                              uppercase
                              (keypress)="allowAlphabets($event)"
                              [required]="depositBankNmRequired"
                              #depositBankNm="ngModel"
                            />
                            <mat-error
                              *ngIf="depositBankNm.errors?.['required']"
                              >Bank name is required</mat-error
                            >
                            <mat-error *ngIf="depositBankNm.errors?.['pattern']"
                              >Bank name is invalid</mat-error
                            >
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Routing Number<ng-container
                              *ngIf="!routingNumRequired"
                              >*</ng-container></mat-label>
                            <input
                              matInput
                              type="text"
                              name="deposit.routingNum"
                              [(ngModel)]="depositRoutingNum"
                              pattern="^\d{9}$"
                              (keypress)="isNumeric($event, routingNumber)"
                              uppercase
                              maxlength="9"
                              (ngModelChange)="routingNumberValidator($event, routingNumber)"
                              [required]="routingNumRequired"
                              #routingNumber="ngModel"
                            />
                            <mat-error
                              *ngIf="routingNumber.errors?.['required'] && !routingNumber.errors?.['nomatch']"
                              >Routing number is required</mat-error
                            >
                            <mat-error *ngIf="routingNumber.errors?.['pattern']"
                              >Routing number is invalid format</mat-error
                            >
                            <mat-error *ngIf="routingNumber.errors?.['nomatch']"
                              >Only numerical values are allowed</mat-error
                            >
                            <mat-error *ngIf="routingNumber.errors?.['invalid']"
                              >Routing number is invalid</mat-error
                            >
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Account Number<ng-container
                              *ngIf="!accountNumRequired"
                              >*</ng-container></mat-label>
                            <input
                              matInput
                              type="text"
                              name="deposit.accountNum"
                              [(ngModel)]="depositAccountNum"
                              pattern="^[0-9]{6,18}$"
                              uppercase
                              maxlength="17"
                              (keypress)="isNumeric($event, accountNumber)"
                              (blur)="phoneCheck($event, accountNumber)"
                              [required]="accountNumRequired"
                              #accountNumber="ngModel"
                            />
                            <mat-error
                              *ngIf="accountNumber.errors?.['required'] && !accountNumber.errors?.['nomatch']"
                              >Account Number is required</mat-error
                            >
                            <mat-error *ngIf="accountNumber.errors?.['pattern']"
                              >Account Number is invalid</mat-error
                            >
                            <mat-error *ngIf="accountNumber.errors?.['nomatch']"
                              >Only numerical values are allowed</mat-error
                            >
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col p-3">
                          Type of Account* (Please select one):
                        </div>
                        <div class="col">
                          <mat-form-field
                          style="display: none"
                        >
                          <input
                          matInput
                    name="deposit.accountType"
                    [(ngModel)]="accountType"
                    #accountChecked="ngModel"
                    style="display: none"
                    [required]="accountTypeRequired"
                  /><mat-error
                  *ngIf="accountChecked.errors?.['required'] "
                  >Your response is required</mat-error
                >
                  </mat-form-field>
                          <mat-chip-listbox
                            #account
                            aria-label="Fish selection"
                            #accountChecked="ngModel"
                            name="deposit.accountType"
                            [(ngModel)]="accountType"
                            (selectionChange)="accountType = account.value"
                            [required]="accountTypeRequired"
                          >
                            <mat-chip-option>Checking</mat-chip-option>
                            <mat-chip-option>Saving</mat-chip-option>
                          </mat-chip-listbox>
                          <mat-error
                            *ngIf="accountChecked.errors?.['required'] "
                            >Your response is required</mat-error
                          >
                        </div>
                        <div class="col"></div>
                        <div class="col"></div>
                      </div>

                      <p>
                        <span class="fw-bold fs-4">Checking account: </span
                        >Please do not forget to send a copy of your voided check. Your voided check has your bank's routing number and bank account number, both are needed to send you payment by direct deposit
                      </p>
                      <p>
                        <span class="fw-bold fs-4">Savings account: </span>Please do not forget to send a copy of your deposit slip. Your bank account number and ABA routing numbers are needed. You may contact your bank if you do not know these numbers.
                      </p>
                      <br />
                      <section class="example-section">
                        <mat-slide-toggle
                          color="primary"
                          class="example-margin"
                          name="deposit.voidedCheckConfirm"
                          [(ngModel)]="voidedCheckConfirm"
                          #voidedCheckConfirmRef="ngModel"
                          [required]="voidedCheckConfirmRequired"
                          ><span class="text-danger">*</span> By selecting this option, I confirm that the voided check I provide contains accurate banking information and may be used to initiate electronic deposits for premium payments.</mat-slide-toggle
                        >
                      </section>
                      <mat-error
                        *ngIf="voidedCheckConfirmRef.errors?.['required'] && customerForm.submitted"
                        >Your response is required</mat-error
                      >
                    </ng-container>
                    
                  </div>
                  <br />
                  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button
                      mat-raised-button
                      color="warn"
                      matStepperPrevious
                      (click)="clear($event)"
                      style="background-color: #b89d18; color: white"
                    >
                      Previous
                    </button>
                    <button
                      mat-raised-button
                      color="primary"
                      matStepperNext
                      (click)="goForward3()"
                    >
                      Next
                    </button>
                  </div>
                </fieldset>
              </mat-step>

              <mat-step   label="Submit" [completed]="submitCheck()">
                <fieldset
                  class="shadow p-5 mb-1 rounded-5"
                  style="border: 2px solid #63b1bc"
                >
                  <legend
                    class="float-none w-auto p-1 mx-5 fw-bold fs-1"
                    style="color: #0f6db7"
                  >
                    Electronic Signature Agreement
                  </legend>

                  <div class="container-fluid">
                    <br />
                    <div *ngIf="existingMember == 'Yes'">
                      <div>
                        <p
                          class="text-center fw-bold fs-2 text-decoration-underline"
                        >
                          ACKNOWLEDGEMENT
                        </p>
                        <br />
                        <p>
                          By electronically signing this document, you are attesting that you have read and will comply with all rules, regulations and requirements set forth by the Georgia Department of Community Health and administered by Gainwell Technologies as it relates to the Health Insurance Premium Payment (HIPP) Program.
                        </p>
                        <p> If you fail to comply with the rules of the program, are no longer eligible for Medicaid, or the Medicaid member(s) no longer participate in employer-sponsored health insurance coverage, you will be ineligible for the program.</p>

                      </div>
                      <br />
                        <h4><strong> Policyholder signature is required.</strong>
                        </h4>
                      <div class="row">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >First Name<ng-container
                                *ngIf="!signfirstNmRequired"
                                >*</ng-container
                              ></mat-label
                            >
                            <input
                              matInput
                              type="text"
                              name="signfirstNm"
                              [(ngModel)]="formGa.referralCase.signFirstName"
                              maxlength="20"
                              #signFN="ngModel"
                              [required]="signfirstNmRequired"
                              uppercase
                              pattern="^[a-zA-Z](?!.*--)(?!.*-')(?!.* ')(?!.*'-)(?!.*' )(?!.* -)(?!.*- )(?!.*  )(?!.*'')[a-zA-Z \-']+$"
                              (keypress)="allowAlphabets2($event, signFN)"
                              (blur)="nomatchCheck($event, signFN)"
                            />
                            <mat-error *ngIf="signFN.errors?.['required'] && !signFN.errors?.['nomatch']"
                              >First Name is required</mat-error
                            >
                            <mat-error *ngIf="signFN.errors?.['invalid']"
                              >First Name is invalid</mat-error
                            >
                            <mat-error *ngIf="signFN.errors?.['pattern']"
                              >First Name is invalid</mat-error
                            >
                            <mat-error *ngIf="signFN.errors?.['nomatch']"
                              >Only Alphabetical, Space, Hyphen, and Apostrophe
                              are allowed.</mat-error
                            >
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >Last Name<ng-container
                                *ngIf="!signLastNameRequired"
                                >*</ng-container
                              ></mat-label
                            >
                            <input 
                              matInput
                              type="text"
                              name="signLastName"
                              [(ngModel)]="formGa.referralCase.signLastName"
                              maxlength="20"
                              #signLN="ngModel"
                              [required]="signLastNameRequired"
                              uppercase
                              pattern="^[a-zA-Z](?!.*--)(?!.*-')(?!.* ')(?!.*'-)(?!.*' )(?!.* -)(?!.*- )(?!.*  )(?!.*'')[a-zA-Z \-']+$"
                              (keypress)="allowAlphabets2($event, signLN)"
                              (blur)="nomatchCheck($event, signLN)"
                            />
                            <mat-error *ngIf="signLN.errors?.['required'] && !signLN.errors?.['nomatch']"
                              >Last Name is required</mat-error
                            >
                            <mat-error *ngIf="signLN.errors?.['invalid']"
                              >Last Name is invalid</mat-error
                            >
                            <mat-error *ngIf="signLN.errors?.['pattern']"
                              >Last Name is invalid</mat-error
                            >
                            <mat-error *ngIf="signLN.errors?.['nomatch']"
                              >Only Alphabetical, Space, Hyphen, and Apostrophe
                              are allowed.</mat-error
                            >
                          </mat-form-field>
                        </div>
                      </div>
                      <div *ngIf="medicaidMemberList().length > 0">
                        <p class="fw-bold">
                          Select the Medicaid members in your household:
                        </p>
                       
  
                        <table
                          mat-table
                          class="table table-bordered table-hover mat-elevation-z8"
                          style="border: 2px solid #63b1bc"
                        >
                          <thead class="table-success">
                            <tr>
                              <th scope="col">First Name</th>
                              <th scope="col">Middle Initial</th>
                              <th scope="col">Last Name</th>
                              <th scope="col">Medicaid ID</th>
                              <th scope="col">Social Security Number</th>
                              <th scope="col">Date of Birth</th>
                              <th scope="col">Gender</th>
                              <th scope="col">Relationship</th>
                              <th scope="col">Select</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              *ngFor="
                                let p of medicaidMemberList();
                                let i = index
                              "
                            >
                              <td><div style="text-align: center;padding-top: 12px;">{{ p.firstNm }}</div></td>
                              <td><div style="text-align: center;padding-top: 12px;">{{ p.miNm }}</div></td>
                              <td><div style="text-align: center;padding-top: 12px;">{{ p.lastNm }}</div></td>
                              <td><div style="text-align: center;padding-top: 12px;">{{ p.maNum }}</div></td>
                              <td><div style="text-align: center;padding-top: 12px;">{{ p.ssnNum }}</div></td>
                              <td><div style="text-align: center;padding-top: 12px;">{{ p.dobDt }}</div></td>
                              <td>
                                <div style="text-align: center;padding-top: 12px;">
                                  <ng-container *ngIf="p.genderCd == 'F'"
                                    >Female</ng-container
                                  >
                                  <ng-container *ngIf="p.genderCd == 'M'"
                                    >Male</ng-container
                                  >
                                </div>
                              </td>
                              <td><div style="text-align: center;padding-top: 12px;">{{ p.relationshipCd }}</div></td>
                              <td style="vertical-align: top;">
                                  <mat-checkbox color="primary"
                                  [checked]="p.selectedMedicaid"
                                  (change)="toggleMedicaidMemberSelection(p)"
                                  ></mat-checkbox>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div *ngIf="existingMember != 'Yes'">
                      <h4><strong>ELECTRONIC SIGNATURE</strong></h4>
                      <br />
                      <p>
                        I certify under penalty of perjury that the information
                        I have given on this application is true, complete, and
                        correct to the best of my knowledge, including the
                        information I have given regarding the U.S. citizenship
                        or immigration status of all household members. I
                        understand that I and any adult household member will be
                        subject to disqualification and prosecution and will be
                        required to repay ineligible benefits or services if we
                        knowingly give false, incorrect, or incomplete
                        information in order to obtain or try to obtain health
                        care assistance. By signing this application, I give
                        permission for the release of information to the
                        Georgia Department of Health by any persons or agencies
                        who have knowledge of my circumstances.
                      </p>
                      <br />
                      <section class="example-section" required>
                        <mat-slide-toggle
                          color="primary"
                          class="example-margin"
                          name="signElectronicSignatureChecked"
                          #signElectronicCheck="ngModel"
                          [(ngModel)]="signElectronicSignatureChecked"
                          [required]="signElectronicRequired"
                          ><span class="text-danger">*</span> Please slide the
                          toggle button to let us know that you have read the
                          “Electronic Signature Agreement”.</mat-slide-toggle
                        >
                      </section>
                      <mat-error
                        *ngIf="signElectronicCheck.errors?.['required'] && customerForm.submitted"
                        >Your response is required</mat-error
                      >

                      <br />
                      <br />
                    </div>
                    <br />
                    <mat-card class="mat-elevation-z8">
                      <mat-card-header>
                        <div class="row">
                          <div class="col">
                            <mat-label
                              ><span class="text-danger">*</span> Please select
                              the correct description of the person signing this
                              application:</mat-label
                            >
                          </div>
                        </div>
                      </mat-card-header>
                      <mat-card-content>
                        <div class="row">
                          <div class="col">
                            <mat-radio-group
                              #group
                              color="primary"
                              class="example-radio-group"
                              [(ngModel)]="signApplicant"
                              [required]="signApplicantRequired"
                              name="signApplicant"
                              #signApplicat="ngModel"
                              (click)="signApplicantCheck()"
                            >
                              <mat-radio-button
                                #buttons
                                class="example-radio-button"
                                value="self"
                                [required]="signApplicantRequired"
                              >
                                I am the applicant signing for myself
                              </mat-radio-button>
                              <mat-radio-button
                                #buttons
                                class="example-radio-button"
                                value="onbehalf"
                                [required]="signApplicantRequired"
                              >
                                I am signing on the applicant’s behalf
                              </mat-radio-button>
                            </mat-radio-group>
                            <mat-error
                              *ngIf="signApplicat.errors?.['required'] && customerForm.submitted"
                              >Your response is required</mat-error
                            >
                          </div>
                          <div class="col"></div>
                          <div class="col"></div>
                        </div>
                        <div *ngIf="signApplicant =='self'" class="row">
                          <div class="col">Please download and complete the <a style="color: #064EBA;" lang="en" href="javascript:void(0)" (click)="pdfData(consentForm, 'ConsentForm.pdf')">Consent Form</a> and send it back to HIPP Unit.</div>
                          
                        </div>
                        <div *ngIf="signApplicant =='onbehalf'" class="row">
                          <div class="col">Please download and complete the <a style="color: #064EBA;" lang="en" href="javascript:void(0)" (click)="pdfData(authorizationFormPdf, 'AuthorizationForm.pdf')">Authorization Form</a> and send it back to HIPP Unit.</div>
                          
                        </div>
                        <br />
                        <div class="row">
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >First Name<ng-container
                                  *ngIf="!submitterFirstNmRequired"
                                  >*</ng-container
                                ></mat-label
                              >
                              <input
                                matInput
                                type="text"
                                name="submitterfirstNm"
                                [(ngModel)]="
                                  formGa.referralCase.submitterFirstName
                                "
                                maxlength="20"
                                #submitterFN="ngModel"
                                [required]="submitterFirstNmRequired"
                                uppercase
                                pattern="^[a-zA-Z](?!.*--)(?!.*-')(?!.* ')(?!.*'-)(?!.*' )(?!.* -)(?!.*- )(?!.*  )(?!.*'')[a-zA-Z \-']+$"
                                (keypress)="allowAlphabets2($event, submitterFN)"
                                (blur)="nomatchCheck($event, submitterFN)"
                              />
                              <mat-error *ngIf="submitterFN.errors?.['required'] && !submitterFN.errors?.['nomatch']"
                                >First Name is required</mat-error
                              >
                              <mat-error *ngIf="submitterFN.errors?.['invalid']"
                                >First Name is invalid</mat-error
                              >
                              <mat-error *ngIf="submitterFN.errors?.['pattern']"
                                >First Name is invalid</mat-error
                              >
                              <mat-error *ngIf="submitterFN.errors?.['nomatch']"
                                >Only Alphabetical, Space, Hyphen and ' are allowed</mat-error
                              >
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >Last Name<ng-container
                                  *ngIf="!submitterLastNmRequired"
                                  >*</ng-container
                                ></mat-label
                              >
                              <input
                                matInput
                                type="text"
                                name="submitterLastName"
                                [(ngModel)]="
                                  formGa.referralCase.submitterLastName
                                "
                                maxlength="20"
                                #submitterLN="ngModel"
                                [required]="submitterLastNmRequired"
                                uppercase
                                pattern="^[a-zA-Z](?!.*--)(?!.*-')(?!.* ')(?!.*'-)(?!.*' )(?!.* -)(?!.*- )(?!.*  )(?!.*'')[a-zA-Z \-']+$"
                                (keypress)="allowAlphabets2($event, submitterLN)"
                                (blur)="nomatchCheck($event, submitterLN)"
                              />
                              <mat-error *ngIf="submitterLN.errors?.['required'] && !submitterLN.errors?.['nomatch']"
                                >Last Name is required</mat-error
                              >
                              <mat-error *ngIf="submitterLN.errors?.['invalid']"
                                >Last Name is invalid</mat-error
                              >
                              <mat-error *ngIf="submitterLN.errors?.['pattern']"
                                >Last Name is invalid</mat-error
                              >
                              <mat-error *ngIf="submitterLN.errors?.['nomatch']"
                                >Only Alphabetical, Space, Hyphen and ' are allowed</mat-error
                              >
                            </mat-form-field>
                          </div>
                        </div>
                      </mat-card-content>
                    </mat-card>

                    <br />
                    <mat-card class="mat-elevation-z8">
                      <mat-card-content>
                        <div class="container text-center">
                          <div class="row">
                            <div
                              class="col text-danger text-center fw-semibold"
                            >
                              Enter the characters shown below into the box
                              provided before clicking Submit.
                            </div>
                          </div>
                          <br />
                          <div class="row text-center align-items-center">
                            <div class="col-4"></div>
                          
                            <div class="col-4 d-flex">
                              <div
                                class="p-3 text-white rounded fs-1 fw-bold fst-italic"
                                style="background-image: url('app/module/pierhippga/assets/img/capcha7.jpg');
                                       background-size: cover; flex: 2.5; display: flex; align-items: center; justify-content: center;">
                                {{ captchaText }}
                              </div>
                              <div class="d-flex flex-column justify-content-start ms-4" style="flex: 1;">
                                <div class="d-flex flex-column" style="flex: 1;">
                                  <div class="d-flex align-items-center mb-3" style="flex-grow: 0; flex-shrink: 1; flex-basis: 30px;">
                                    <i
                                      class="material-icons"
                                      style="font-size: 2.6rem; color: #007bff; cursor: pointer;"
                                      (click)="playCaptchaAudio()"
                                      title="Play Audio"
                                    >
                                      volume_up
                                    </i>
                                    <span class="ms-2" style="font-size: 1rem;">Play Audio</span>
                                  </div>
                                  <div class="d-flex align-items-center" style="flex-grow: 0; flex-shrink: 1; flex-basis: 30px;">
                                    <i
                                      class="material-icons"
                                      style="font-size: 2.6rem; color: #28a745; cursor: pointer;"
                                      (click)="generateCaptcha()"
                                      title="Refresh Captcha"
                                    >
                                      refresh
                                    </i>
                                    <span class="ms-2" style="font-size: 1rem;">Refresh Captcha</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          <div class="col-4"></div>
                          </div>                                                                                
                          <br/>
                          <div class="row">
                            <div class="col"></div>
                            <div class="col">
                              <mat-form-field appearance="outline">
                                <mat-label
                                  >Captcha<ng-container *ngIf="!captchaRequired"
                                    >*</ng-container
                                  ></mat-label
                                >
                                <input
                                  matInput
                                  type="text"
                                  name="captcha"
                                  [(ngModel)]="captchaEntered"
                                  #captcha="ngModel"
                                  [required]="captchaRequired"
                                  (blur)="checkCaptch($event)"
                                  minlength="6"
                                  maxlength="6"
                                />
                                <mat-error *ngIf="captcha.errors?.['required']"
                                  >Captcha code is required</mat-error
                                >
                                <mat-error *ngIf="captcha.errors?.['nomatch']"
                                  >Captcha code does not match</mat-error
                                >
                              </mat-form-field>
                            </div>
                            <div class="col"></div>
                          </div>
                          <div class="row justify-content-md-center">
                            <div class="col">
                              <button
                                mat-raised-button
                                color="warn"
                                matStepperPrevious
                                class="m-2"
                                style="background-color: #b89d18; color: white"
                                (click)="goBack5()"
                              >
                                Previous
                              </button>

                              <button
                                mat-raised-button
                                color="primary"
                                id="formSubmit"
                                type="submit"
                                class="m-2"
                                [disabled]="
                                  customerForm.pristine || !customerForm.valid
                                "
                                (click)="goForward5()"
                              >
                                {{ operationText }}
                              </button>
                              <button
                                mat-raised-button
                                id="formReset"
                                class="m-2"
                                type="button"
                                [disabled]="
                                  customerForm.pristine || !customerForm.valid
                                "
                                (click)="cancel($event)"
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        </div>
                      </mat-card-content>
                    </mat-card>
                  </div>
                  <br />

                  <div class="alert alert-danger" *ngIf="errorMessage">
                    {{ errorMessage }}
                  </div>

                  <br />
                </fieldset>
              </mat-step>
              <br />
            </mat-horizontal-stepper>
          </div>
        </form>
      </div>
    </div>
    <div class="form-bg" *ngIf="isValidFormSubmitted">
      <ng-container *ngIf="submittedResponse.referralId != undefined">
        <div class="row">
          <div class="col">
            <app-timer-ga
              [isValidFormSubmitted]="isValidFormSubmitted"
              (changeResetMessageCalled)="changeResetMessage()"
            ></app-timer-ga>
            <br />
          </div>
        </div>
        <div
          class="container-fluid rounded p-3 bg-light"
          style="border: 2px solid #63b1bc"
        >
          <fieldset
            class="shadow p-5 mb-1 rounded-5"
            style="border: 2px solid #63b1bc"
          >
            <legend
              class="float-none w-auto p-1 mx-5 fw-bold fs-1"
              style="color: #0f6db7"
            >
              Your GA HIPP application has been submitted.
            </legend>
  
            <div class="container  text-center">
              <p class="fw-bold">
                Confirmation ID : {{ submittedResponse.referralId }}
              </p>
              <p>
                Your application has been submitted successfully. Please
                <a href="javascript:void(0)" (click)="openPdf()">print</a> and/or save a copy for your records.
                
              </p>
              <h4> <strong><a style="color: #064EBA;" lang="en" href="javascript:void(0)" (click)="pdfData(faqFormPdf, 'FAQ_Form.pdf')">Frequently Asked Questions/Glossary</a></strong></h4>
            </div>
          </fieldset>
          <br />
        </div>
      </ng-container>
      <ng-container *ngIf="submittedResponse.referralId == undefined">
        <div class="container text-center text-danger-emphasis bg-danger-subtle rounded-3">
          <br/>
          <p class="fs-1"><i class="bi bi-exclamation-circle-fill "></i></p>
          <ng-container *ngIf="apiError && apiError.status == 500">
            <h1>Something Went Wrong</h1>
            <h4>Sorry! Your request could not be processed as something went wrong on our side.</h4>
            <h4>{{getMessageServerDown()}}</h4>
          </ng-container>
          <ng-container *ngIf="apiError && apiError.status != 500">
            <h1>Error occured from server side <strong> {{apiError.status}} {{apiError.statusText}}</strong>  </h1>
            <h4>Your request could not be processed due to below error</h4>
            <p>
              <ng-container *ngIf="apiError.error.detail">{{apiError.error.detail}}</ng-container>
              <ng-container *ngIf="!apiError.error.detail">{{apiError.message}}</ng-container>
              </p>
          </ng-container>
          <br/>
        </div>
      </ng-container>
      
    </div>
  </mat-card-content>
</mat-card>